import "./CmClaim.scss";
import { useEffect, useRef, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { motion } from "framer-motion";
import { IoClose, IoDocumentTextSharp, IoLocationSharp } from "react-icons/io5";
import { FaSave } from "react-icons/fa";
import CircularButton, {
  CustomLoadingButton,
} from "../../../components/ui/CustomButton.jsx";
import { showToast } from "../../../toastService.js";
import DescriptionIcon from "@mui/icons-material/Description";
import { MdAdd, MdClose, MdForum, MdOutlineMenuOpen, MdPhone, MdOutlineSmokeFree, MdGroupWork, MdOutlinePayments, MdEdit, MdDelete, MdAlternateEmail } from "react-icons/md";
import { IoMdArrowRoundUp, IoMdArrowRoundDown } from "react-icons/io";
import RefreshIcon from "@mui/icons-material/Refresh";
import { BsSuitcaseLgFill } from "react-icons/bs";
import { LuLayoutList, LuListTree } from "react-icons/lu";
import { GrStatusCriticalSmall } from "react-icons/gr";
import InboxIcon from '@mui/icons-material/MoveToInbox';
import MailIcon from '@mui/icons-material/Mail';
import TagIcon from '@mui/icons-material/Tag';
import { TbCertificate, TbGenderEpicene } from "react-icons/tb";
import { PiGenderMaleBold, PiGenderFemaleBold } from "react-icons/pi";
import {
  DialogActions,
  Dialog,
  DialogTitle,
  DialogContent,
  Tooltip,
  Table,
  TableContainer,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  TablePagination
} from "@mui/material";
import Select from "react-select";
import CreatableSelect from "react-select/creatable";
import AsyncSelect from "react-select/async";
import { customSelectStyles_dark, customSelectStyles_light } from "../../../components/ui/CustomSelect.jsx";
import moment from "moment";
import numeral from "numeral";
import newRequest from "../../../utils/newRequest.js";
import AllFiles from "../../../components/allFiles/AllFiles.jsx";
import Big from "big.js";
import ConfirmDialog from "../../../components/confirmDialog/confirmDialog.jsx";
import Confetti from "react-confetti";
import { GridLoader, ScaleLoader } from "react-spinners";
import { calculatePercentage, capitalizeFirstLetter, fetchClientsBySearch, formatNumber, formatNumberWithDigitGrouping, formatStringToNumberV2, getTodaysDateWithoutTime, handleOpenMap, numberToWordsWithDecimal } from "../../../utils/genericFunctions.js";
import AllDocsNote from "../../../components/allDocsNote/AllDocsNote.jsx";
import { ToggleSwitch } from "../../../components/toogle/ToggleSwitch.jsx";
import SubjectIcon from '@mui/icons-material/Subject';
import Badge from '@mui/material/Badge';
import EventNoteIcon from '@mui/icons-material/EventNote';
import TopicIcon from '@mui/icons-material/Topic';
import CommentIcon from '@mui/icons-material/Comment';
import FileUploadComponent from "../../../components/fileUploadComponent/FileUploadComponent.jsx";
import Correspondence from "../../../components/correspondence/Correspondence.jsx";
import Box from '@mui/material/Box';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import Divider from '@mui/material/Divider';
import ListItem from '@mui/material/ListItem';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import GaugePointer from "../../../components/gaugePointer/GaugePointer.jsx";
import ExpandableComponent from "../../../components/expandableComponent/ExpandableComponent.jsx";
import EmailComponent from "../../../components/emailComponent/EmailComponent.jsx";
import WorkedOnBy from "../../../components/workedOnBy/WorkedOnBy.jsx";
import OnScreenReports from "../../../components/onScreenReports/OnScreenReports.jsx";
import { useTranslation } from "react-i18next";
import { CiImageOn } from "react-icons/ci";
import InitialsAvatar from "../../../components/InitialsAvatar/InitialsAvatar.jsx";
import Collaborator from "../../../components/Collaborator/Collaborator.jsx";
import { qilloIconMap } from "../../../utils/iconMapping.js";
import { GoHomeFill } from "react-icons/go";
import GooglePlacesSelect from "../../../components/googlePlacesSelect/GooglePlacesSelect.jsx";


const CmClaim = () => {
  const { t } = useTranslation();
  const { currentUser } = useSelector((state) => state.user);
  const { currentTheme } = useSelector((state) => state.theme);
  const [isProcessing, setIsProcessing] = useState(false);
  const [isNotifyDialogOpen, setIsNotifyDialogOpen] = useState(false);
  const [notifyDialogTitle, setNotifyDialogTitle] = useState("Confirm");
  const [notifyDialogText, setNotifyDialogText] = useState("Text");
  const [isLoading, setIsLoading] = useState(false);
  const [injuredDialogOpen, setInjuredDialogOpen] = useState(false);
  const navigate = useNavigate();
  const location = useLocation();
  const parts = location.pathname.split("/");
  const [claimData, setClaimData] = useState(null);
  const [claimDocId, setClaimDocId] = useState(parts[parts.length - 1]);
  const [savingTitle, setSavingTitle] = useState("Save");
  const [documentEnabled, setDocumentEnabled] = useState("Y");
  const [nextAction, setNextAction] = useState("Validate");
  const [summaryCurrentView, setSummaryCurrentView] = useState("summary");
  const [isConfettiActive, setIsConfettiActive] = useState(false);
  const [objectToAction, setObjectToAction] = useState({
    object_id: "",
    action_text: "",
    new_doc_status: "",
    param1: "",
    param2: "",
  });
  const [invokedAction, setInvokedAction] = useState("");
  const [isConfirmDialogOpen, setIsConfirmDialogOpen] = useState(false);
  const [confirmDialogAction, setConfirmDialogAction] = useState("None");

  const [isCollabOpen, setIsCollabOpen] = useState(false);
  const openCollab = () => setIsCollabOpen(true);
  const closeCollab = () => setIsCollabOpen(false);
  const pageShellRef = useRef(null);
  const [collabRightOffset, setCollabRightOffset] = useState(0);

  // email component 
  const [emailDialogOpen, setEmailDialogOpen] = useState(false);
  const [emailData, setEmailData] = useState(null);
  // reports
  const [reportsDialogOpen, setReportsDialogOpen] = useState(false);
  const actionsMenuRef = useRef(null);
  const [openOptions, setOpenOptions] = useState(false);

  // payment fields
  const [isPaymentOpened, setIsPaymentOpened] = useState(false);
  const [paymentAction, setPaymentAction] = useState(null);
  const [paymentId, setPaymentId] = useState(null);
  const [paymentNo, setPaymentNo] = useState(null);
  const [paymentMode, setPaymentMode] = useState(null);
  const [paymentNarration, setPaymentNarration] = useState(null);
  const [paymentChqno, setPaymentChqno] = useState(null);
  const [paymentDate, setPaymentDate] = useState(null);
  const [paymentFcAmount, setPaymentFcAmount] = useState(null);
  const [paymentLcAmount, setPaymentLcAmount] = useState(null);
  const [selectedReserveAction, setSelectedReserveAction] = useState(null);

  // reserve details
  const [isReserveOpened, setIsReserveOpened] = useState(false);
  const [reserveId, setReserveId] = useState(null);


  const [reserveTypes, setReserveTypes] = useState(null);
  const [reserveAction, setReserveAction] = useState(null);
  const [reserveType, setReserveType] = useState(null);
  const [reserveEntity, setReserveEntity] = useState(null);
  const [reserveDesc, setReserveDesc] = useState(null);
  const [reserveAmountFc, setReserveAmountFc] = useState(null);
  const [reserveAmountLc, setReserveAmountLc] = useState(null);
  const [reserveView, setReserveView] = useState("reserves");
  const [reserves, setReserves] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(0);
  const [selectedReserve, setSelectedReserve] = useState(null);
  const [selectedReserveMovement, setSelectedReserveMovement] = useState(null);
  const [currentReserveMovement, setCurrentReserveMovement] = useState(null);

  const [rowsPerPage, setRowsPerPage] = useState(5);
  const [currentPage, setCurrentPage] = useState(0);

  const slicedReserves = reserves?.slice(
    currentPage * rowsPerPage,
    currentPage * rowsPerPage + rowsPerPage
  );



  // number generation
  const [numGeneration, setNumGeneration] = useState({});

  // claim fields
  const [cmClaimNo, setCmClaimNo] = useState(null);
  const [cmAmountFc, setCmAmountFc] = useState(0);
  const [cmAmountLc, setCmAmountLc] = useState(0);
  const [cmStatus, setCmStatus] = useState(null);
  const [cmRiskNoteNo, setCmRiskNoteNo] = useState(null);
  const [cmPolicyNo, setCmPolicyNo] = useState(null);
  const [cmRiskNoteDocid, setCmRiskNoteDocid] = useState(null);
  const [cmLossDate, setCmLossDate] = useState(new Date());
  const [cmIntimationDate, setCmIntimationDate] = useState(new Date());
  const [createdDate, setCreatedDate] = useState(new Date());
  const [cmDescription, setCmDescription] = useState(null);
  const [cmLocation, setCmLocation] = useState(null);
  const [cmArea, setCmArea] = useState(null);
  const [cmRiskCode, setCmRiskCode] = useState(null);
  const [cmRiskDocid, setCmRiskDocid] = useState(null);
  const [cmRiskTotalLoss, setCmRiskTotalLoss] = useState(null);
  const [cmInjury, setCmInjury] = useState(null);
  const [cmInjuredList, setCmInjuredList] = useState([]);
  const [cmCoverCode, setCmCoverCode] = useState(null);
  const [cmCoverDocid, setCmCoverDocid] = useState(null);
  const [cmStage, setCmStage] = useState(null);
  const [claimStages, setClaimStages] = useState([]);
  const [basisOfClaimXx, setBasisOfClaimXx] = useState([]);
  const [summaryNotesXx, setSummaryNotesXx] = useState([]);
  const [currentStageXx, setCurrentStageXx] = useState(null);

  const [placesDialogOpen, setPlacesDialogOpen] = useState(false);
  const [selectedPlace, setSelectedPlace] = useState(null);
  const [cmLatitude, setCmLatitude] = useState(null);
  const [cmLongitude, setCmLongitude] = useState(null);
  const [cmPlaceName, setCmPlaceName] = useState(null);
  const [cmLossArea, setCmLossArea] = useState(null);
  const [riskAreas, setRiskAreas] = useState([]);

  // injured person
  const [injuredFullName, setInjuredFullName] = useState("");
  const [injuredIdNumber, setInjuredIdNumber] = useState("");
  const [injuredAge, setInjuredAge] = useState(0);
  const [injuredGender, setInjuredGender] = useState(null);
  const [injuredInjuryDesc, setInjuredInjuryDesc] = useState("");
  const [injuredFatal, setInjuredFatal] = useState("N");
  const [injuredAction, setInjuredAction] = useState("");

  // end of claim fields
  // claim close and reopen reasons
  const [selectedCloseReason, setSelectedCloseReason] = useState(null);
  const [closeReasons, setCloseReasons] = useState([]);
  const [closeRemarks, setCloseRemarks] = useState("");
  const [isCloseDialogOpened, setIsCloseDialogOpened] = useState(false);
  const [selectedReopenReason, setSelectedReopenReason] = useState(null);
  const [reopenRemarks, setReopenRemarks] = useState("");
  const [reopenReasons, setReopenReasons] = useState([]);
  const [isReopenDialogOpened, setIsReopenDialogOpened] = useState(false);

  // attachments

  const [attachmentsData, setAttachmentsData] = useState([]);
  const [reserveAttachments, setReserveAttachments] = useState([]);

  const [openDrawer, setOpenDrawer] = useState(false);
  const [genders, setGenders] = useState([]);

  const setTypes = () => {
    try {
      const options = ["Own Damage", "Service Provider", "Third Party"].map((val) => ({
        value: val,
        label: val,
      }));
      setReserveTypes(options);
    } catch (error) {
      console.error("Error fetching receipt modes :", error);
    }
  };

  const handlePageChange = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 5));
    setCurrentPage(0);
  };

  const fetchReserves = async (claim_docid) => {
    try {
      const res = await newRequest.get(`/cmReserve/findById/${claim_docid}`);
      // console.log(`fetchReserves ${JSON.stringify(res.data, null, 2)}`);
      setReserves(res.data);
      if (res.data) {
        setSelectedReserve(res.data[0]);
        setSelectedReserveMovement(null);
        setSelectedReserveMovement(res.data[0]?.cr_movement_xx);
      }
    } catch (error) {
      console.error("Error fetching reserves :", error);
    }
  };

  const toggleDrawer = (newOpen) => () => {
    setOpenDrawer(newOpen);
  };

  const DrawerList = (
    <Box sx={{ width: 250 }} role="presentation" onClick={toggleDrawer(false)}>
      <List>
        {['Inbox', 'Starred', 'Send email', 'Drafts'].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton>
              <ListItemIcon>
                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
              </ListItemIcon>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
      <Divider />
      <List>
        {['All mail', 'Trash', 'Spam'].map((text, index) => (
          <ListItem key={text} disablePadding>
            <ListItemButton>
              <ListItemIcon>
                {index % 2 === 0 ? <InboxIcon /> : <MailIcon />}
              </ListItemIcon>
              <ListItemText primary={text} />
            </ListItemButton>
          </ListItem>
        ))}
      </List>
    </Box>
  );



  const handleReserveFcAmountBlur = async (e) => {
    if (e.target.value) {
      try {
        const strippedValue = e.target.value.replace(/,/g, "");
        if (isNaN(strippedValue)) {
          setNotifyDialogTitle("Error!");
          setNotifyDialogText(`Invalid Number <strong>${strippedValue}</strong>`);
          setIsNotifyDialogOpen(true);
          return;
        }
        const parsedValue = Big(strippedValue);

        // console.log(`parsedValue is ${parsedValue}`)
        // console.log(`getTodaysDateWithoutTime is ${getTodaysDateWithoutTime()}`)

        // get currency rate
        const end_res = await newRequest.post("/glCurrencyRate/find", {
          rate_org_code: currentUser.usr_org_code,
          rate_cur_code_fm: claimData?.policy_xx?.pl_cur_code,
          rate_cur_code_to: currentUser.currency_code_xx,
          rate_date: getTodaysDateWithoutTime(),
        });

        setReserveAmountFc(formatNumber(parsedValue, 2));
        const lcAmount = Number(parseFloat(formatStringToNumberV2(parsedValue) * end_res.data.rate).toFixed(2));
        setReserveAmountLc(lcAmount);
      } catch (error) {
        console.log(error);
      }
    }
  };

  const handleInsuredPerson = async () => {
    try {
      if (!injuredFullName) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter full name!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (!injuredGender?.value) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please select gender!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (!injuredInjuryDesc) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter injury description!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      // update claim injured flag
      await newRequest.put(
        `/cmClaim/upd/${claimDocId}`,
        {
          cm_injury: cmInjury,
          updatedBy: currentUser.usr_id,
        }
      );

      if (injuredAction === "add") {
        await newRequest.post(
          "/cmClaim/addInjured/",
          {
            claim_docid: claimDocId,
            full_name: injuredFullName,
            age: injuredAge,
            gender: injuredGender?.value,
            injury_desc: injuredInjuryDesc,
            id_number: injuredIdNumber,
            fatal: injuredFatal
          }
        );
      } else {
        await newRequest.post(
          "/cmClaim/updInjured/",
          {
            claim_docid: claimDocId,
            injured_person_docid: objectToAction.object_id,
            full_name: injuredFullName,
            age: injuredAge,
            gender: injuredGender?.value,
            injury_desc: injuredInjuryDesc,
            id_number: injuredIdNumber,
            fatal: injuredFatal,
            updatedBy: currentUser.usr_id,
          }
        );
      }

      // console.log(`addInjured  ${JSON.stringify(res.data, null, 2)}`);
      // refresh list
      const getInjured = await newRequest.post(
        "/cmClaim/getInjured/",
        {
          claim_docid: claimDocId,
        }
      );
      // console.log(`getInjured  ${JSON.stringify(getInjured.data, null, 2)}`);
      setCmInjuredList(getInjured.data);
      resetInjuredData();

      if (injuredAction === "amend") {
        setInjuredDialogOpen(false);
        showToast("Updated!", "success");
      } else {
        showToast("Added!", "success");
      }
    } catch (error) {
      console.log(error);
    }
  };

  const resetInjuredData = () => {
    try {
      setInjuredFullName("");
      setInjuredIdNumber("");
      setInjuredAge(0);
      setInjuredGender({
        value: "",
        label: "",
      });
      setInjuredInjuryDesc("");
      setInjuredFatal("N");
      setInjuredAction("");
    } catch (error) {
      console.log(error);
    }
  };

  const handleKeyDown = (e) => {
    if (e.key === "Enter" && !e.shiftKey) {
      e.preventDefault();
      handleReserveAddUpdate();
    }
  };

  const handlePlaceSelect = (place) => {
    try {
      if (!place) {
        setSelectedPlace(null);
        setCmLatitude(null);
        setCmLongitude(null);
        setCmPlaceName(null);
      } else {
        setSelectedPlace(place);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const amendInjuredPerson = async (person) => {
    try {
      setInjuredFullName(person?.full_name);
      setInjuredIdNumber(person?.id_number);
      setInjuredAge(person?.age);
      setInjuredGender({
        value: person?.gender,
        label: person?.gender_xx,
      });
      setInjuredInjuryDesc(person?.injury_desc);
      setInjuredFatal(person?.fatal);
      setInjuredAction("amend");
      setInjuredDialogOpen(true);
    } catch (error) {
      console.log(error);
    }
  };



  const fetchClaim = async (firstTime = false) => {
    try {
      if (firstTime) {
        setIsLoading(true);
      }

      if (claimDocId === "new" && claimData._id) {
        setClaimDocId(claimData._id);
      }
      const res = await newRequest.get(`/cmClaim/findById/${claimDocId}`);
      // console.log(`setClaimData  ${JSON.stringify(res.data, null, 2)}`);
      setClaimData(res.data);

      if (res.data) {


        if (res.data.cm_amount_fc) {
          setCmAmountFc(formatNumberWithDigitGrouping(res.data.cm_amount_fc, 2));
        }

        if (res.data.cm_amount_lc) {
          setCmAmountLc(res.data.cm_amount_lc);
        }

        if (res.data.cm_description) {
          setCmDescription(res.data.cm_description);
        }

        if (res.data.cm_location) {
          setCmLocation(res.data.cm_location);
        }
        if (res.data.cm_area) {
          setCmArea(res.data.cm_area);
        }
        if (res.data.cm_risk_code) {
          setCmRiskCode(res.data.cm_risk_code);
        }
        if (res.data.cm_risk_docid) {
          setCmRiskDocid(res.data.cm_risk_docid);
        }
        if (res.data.cm_risk_total_loss) {
          setCmRiskTotalLoss(res.data.cm_risk_total_loss);
        }


        if (res.data.cm_injury) {
          setCmInjury(res.data.cm_injury);
        }

        if (res.data.cm_injured_list) {
          setCmInjuredList(res.data.cm_injured_list);
        }

        if (res.data.cm_loss_date) {
          const formattedDate = moment(res.data.cm_loss_date).format("YYYY-MM-DD");
          setCmLossDate(formattedDate);
        } else {
          setCmLossDate(null);
        }

        if (res.data.cm_intimation_date) {
          const formattedDate = moment(res.data.cm_intimation_date).format("YYYY-MM-DD");
          setCmIntimationDate(formattedDate);
        } else {
          setCmIntimationDate(null);
        }

        if (res.data.createdAt) {
          const formattedDate = moment(res.data.createdAt).format("DD-MMM-YYYY");
          setCreatedDate(formattedDate);
        }


        if (res.data.current_stage_xx) {
          setCurrentStageXx(res.data.current_stage_xx);
        }

        if (res.data.cm_stage) {
          setCmStage({
            value: res.data.cm_stage,
            label: res.data.current_stage_xx,
          });
        } else {
          setCmStage(null);
        }

        if (res.data.summary_notes_xx) {
          setSummaryNotesXx(res.data.summary_notes_xx);
        } else {
          setSummaryNotesXx(null);
        }


        if (res.data.cm_cover_code) {
          setCmCoverCode(res.data.cm_cover_code);
        } else {
          setCmCoverCode(null);
        }

        if (res.data.cm_claim_no) {
          setCmClaimNo(res.data.cm_claim_no);
        } else {
          setCmClaimNo(null);
        }

        if (res.data.cm_loss_area) {
          setCmLossArea({
            value: res.data.cm_loss_area,
            label: res.data.cm_loss_area_xx,
          });
        } else {
          setCmLossArea(null);
        }

        // google places
        setCmLatitude(res.data?.cm_latitude);
        setCmLongitude(res.data?.cm_longitude);
        setCmPlaceName(res.data?.cm_place_name);

        setDocumentEnabled(res.data.document_enabled_xx);
        setNextAction(res.data.next_action_xx);

        // fetch reserves
        await fetchReserves(res.data._id);
        // fetch attachements
        await fetchDocumentAttachments("CM Claim", res.data._id);
      }
    } catch (err) {
      setIsLoading(false);
      console.log(err);
    } finally {
      if (firstTime) {
        setIsLoading(false);
      }
    }
  };


  const fetchGenders = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Gender" });
      const options = res.data.map((gender) => ({
        value: gender.sys_code,
        label: gender.sys_name,
      }));

      setGenders(options);
    } catch (error) {
      console.error("Error fetching entity Gender:", error);
    }
  };

  const fetchDocumentAttachments = async (docType, docid) => {
    try {
      const res = await newRequest.post("/files/findDocFiles", {
        fl_doc_type: docType,
        fl_parent_doc_id: docid,
      });
      setAttachmentsData(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchReserveAttachments = async (docType, docid) => {
    try {
      const res = await newRequest.post("/files/findDocFiles", {
        fl_doc_type: docType,
        fl_parent_doc_id: docid,
      });
      setReserveAttachments(res.data);
    } catch (err) {
      console.log(err);
    }
  };

  const fetchClaimStage = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Claim Stages" });
      const options = res.data.map((mode) => ({
        value: mode.sys_code,
        label: mode.sys_name,
      }));
      setClaimStages(options);
    } catch (error) {
      console.error("Error fetching receipt modes :", error);
    }
  };

  const fetchRiskAreas = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Risk Areas", });
      const options = res.data.map((codes) => ({
        value: codes?.sys_code,
        label: codes?.sys_name,
      }));
      setRiskAreas(options);
    } catch (error) {
      console.error("Error fetching risk areas :", error);
    }
  };


  const fetchCloseReasons = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Claim Close Reasons" });
      const options = res.data.map((mode) => ({
        value: mode.sys_code,
        label: mode.sys_name,
      }));
      setCloseReasons(options);
    } catch (error) {
      console.error("Error fetching receipt modes :", error);
    }
  };

  const handleSelectedCloseReason = async (selectedOption) => {
    try {
      if (selectedOption && selectedOption.__isNew__) {
        await newRequest.post("sysCode/add", {
          sys_org_code: currentUser.usr_org_code,
          sys_type: "Claim Close Reasons",
          sys_code: selectedOption.value,
          sys_name: selectedOption.value,
          userCode: currentUser.usr_id,
        });

        setSelectedCloseReason({
          value: selectedOption.value,
          label: selectedOption.value,
        });

        showToast(`${selectedOption.value} added to the list!`, "success");
      } else {
        setSelectedCloseReason(selectedOption);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleSelectedReopenReason = async (selectedOption) => {
    try {
      if (selectedOption && selectedOption.__isNew__) {
        await newRequest.post("sysCode/add", {
          sys_type: "Claim Reopen Reasons",
          sys_code: selectedOption.value,
          sys_name: selectedOption.value
        });

        setSelectedReopenReason({
          value: selectedOption.value,
          label: selectedOption.value,
        });

        showToast(`${selectedOption.value} added to the list!`, "success");
      } else {
        setSelectedReopenReason(selectedOption);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const fetchReopenReasons = async () => {
    try {
      const res = await newRequest.post("/sysCode/findAll", { sys_type: "Claim Reopen Reasons" });
      const options = res.data.map((mode) => ({
        value: mode.sys_code,
        label: mode.sys_name,
      }));
      setReopenReasons(options);
    } catch (error) {
      console.error("Error fetching receipt modes :", error);
    }
  };

  const handleCloseClaim = async () => {
    try {
      if (!selectedCloseReason) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please select reason for closing this claim!`);
        setIsNotifyDialogOpen(true);
        return;
      }
      if (!closeRemarks) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter remarks!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      // update claim status
      await newRequest.post(
        "/cmClaim/updStatus/",
        {
          claim_docid: claimDocId,
          cm_status: objectToAction.new_doc_status,
          userCode: currentUser.usr_id,
        }
      );

      try {
        await newRequest.post("/trace/add", {
          trc_org_code: currentUser.usr_org_code,
          trc_action_on: "Document",
          trc_doc_type: "Claim",
          trc_doc_no: claimData.cm_our_ref,
          trc_aent_code: "",
          trc_ent_code: "",
          trc_action: selectedCloseReason.value,
          trc_remarks: `updated status to ${objectToAction.new_doc_status}. Entered remarks : ${closeRemarks}`,
          trc_tags: [objectToAction.new_doc_status, selectedCloseReason.value],
          trc_doc_docid: claimDocId,
          userCode: currentUser.usr_id,
        });

        setSelectedCloseReason(null);
        setCloseReasons([]);
        setCloseRemarks("");
        setIsCloseDialogOpened(false);

        handleConfettiClick();
        fetchClaim();
      } catch (error) {
        console.log(error);
      }
    } catch (error) {
      console.log(error);
    }
  };


  const handleReserveAddUpdate = async () => {
    try {

      // reserveAction === "add" ? "Add" : "Update"
      console.log(`reserveAction : ${reserveAction}`)
      console.log(`reserveType?.value : ${reserveType?.value}`)
      console.log(`reserveEntity?.value : ${reserveEntity?.value}`)
      console.log(`reserveAmountFc : ${reserveAmountFc} formatted ${formatStringToNumberV2(reserveAmountFc)}`)
      console.log(`reserveAmountLc : ${reserveAmountLc} formatted ${formatStringToNumberV2(reserveAmountLc)}`)


      // check reserve must be greater than zero 
      if (reserveAction === "add" && reserveAmountLc === 0) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`While adding a reserve, you must provide the amount!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      // check Service Provider reseve must have entity
      if (reserveAction === "add" && reserveType?.value === "Service Provider" && !reserveEntity) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`You must specify the entity to be used as Service Provider!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (reserveAction === "edit" && reserveType?.value === "Own Damage" && !reserveDesc) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Narration is mandatory!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      // add new reserve
      if (reserveAction === "add") {
        const res = await newRequest.post(
          "/cmReserve/add/",
          {
            cr_claim_no: claimData?.cm_claim_no,
            cr_claim_docid: claimData?._id,
            cr_type: reserveType?.value,
            cr_description: reserveDesc || reserveEntity?.label,
            cr_ent_code: reserveEntity?.value,
            cr_amount_fc: formatStringToNumberV2(reserveAmountFc),
            cr_amount_lc: formatStringToNumberV2(reserveAmountLc)
          }
        );
        if (res.status === 200) {
          await fetchClaim();
          resetReverAmounts();
          setIsReserveOpened(false);
          showToast(
            `Reserve added!`,
            "success"
          );
        } else {
          resetReverAmounts();
          setIsReserveOpened(false);
          showToast(
            `Error adding reserve!`,
            "error"
          );
        }
      } else if (reserveAction === "edit") {
        const res = await newRequest.put(
          `/cmReserve/upd/${reserveId}`,
          {
            cr_description: reserveDesc || reserveEntity?.label,
            cr_ent_code: reserveEntity?.value,
            cr_amount_fc: formatStringToNumberV2(reserveAmountFc),
            cr_amount_lc: formatStringToNumberV2(reserveAmountLc)
          }
        );
        // console.log(`res status ${res.status}`)
        if (res.status === 200) {
          await fetchClaim();
          resetReverAmounts();
          setIsReserveOpened(false);
          showToast(
            `Reserve updated!`,
            "success"
          );
        } else {
          resetReverAmounts();
          setIsReserveOpened(false);
          showToast(
            `Error updating reserve!`,
            "error"
          );
        }
      }
    } catch (error) {
      console.log(error);
    }
  };

  const resetReverAmounts = () => {
    try {
      setReserveAction(null);
      setReserveType(null);
      setReserveEntity(null);
      setReserveDesc(null);
      setReserveAmountFc(null);
      setReserveAmountLc(null);
    } catch (error) {
      console.log(error)
    }
  }
  const handleReopenClaim = async () => {
    try {

      if (!selectedReopenReason) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please select reason for reopening this claim!`);
        setIsNotifyDialogOpen(true);
        return;
      }
      if (!reopenRemarks) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter remarks!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      // update claim status
      await newRequest.post(
        "/cmClaim/updStatus/",
        {
          claim_docid: claimDocId,
          cm_status: objectToAction.new_doc_status
        }
      );

      try {
        await newRequest.post("/trace/add", {
          trc_action_on: "Document",
          trc_doc_type: "Claim",
          trc_doc_no: claimData.cm_our_ref,
          trc_aent_code: "",
          trc_ent_code: "",
          trc_action: selectedReopenReason.value,
          trc_remarks: `updated status to ${objectToAction.new_doc_status}. Entered remarks : ${reopenRemarks}`,
          trc_tags: [objectToAction.new_doc_status, selectedReopenReason.value],
          trc_doc_docid: claimDocId
        });

        setSelectedReopenReason(null);
        setReopenReasons([]);
        setReopenRemarks("");
        setIsReopenDialogOpened(false);
        fetchClaim();
      } catch (error) {
        console.log(error);
      }
    } catch (error) {
      console.log(error);
    }
  };

  const handleConfettiClick = () => {
    setIsConfettiActive(true);
    // Set a timeout to stop the confetti after a few seconds (optional)
    setTimeout(() => {
      setIsConfettiActive(false);
    }, 5000);
  };


  const handleConfirm = async () => {
    try {
      if (confirmDialogAction === "deleteInjured") {
        setIsProcessing(true);
        // do all necessary checks
        await newRequest.post(
          "/cmClaim/delInjured",
          {
            claim_docid: claimDocId,
            injured_person_docid: objectToAction.object_id,
          }
        );

        try {
          await newRequest.post("/trace/add", {
            trc_action_on: "Document",
            trc_doc_type: "Claim",
            trc_doc_no: claimData.cm_our_ref,
            trc_aent_code: "",
            trc_ent_code: "",
            trc_action: "deleted injured person",
            trc_remarks: `deleted ${objectToAction.param1} from injured people list`,
            trc_tags: ["deleted injured person"],
            trc_doc_docid: claimDocId
          });
        } catch (error) {
          console.log(error);
        }

        // refresh list
        const getInjured = await newRequest.post("/cmClaim/getInjured/", { claim_docid: claimDocId });
        setCmInjuredList(getInjured.data);
        setIsProcessing(false);
      } else if (confirmDialogAction === "claimAction") {
        // console.log(`objectToAction.new_doc_status ${objectToAction.new_doc_status}`)
        try {
          if (objectToAction.new_doc_status === "Closed") {
            fetchCloseReasons();
            setIsConfirmDialogOpen(false);
            setIsCloseDialogOpened(true);
          } else if (objectToAction.new_doc_status === "Opened") {
            fetchReopenReasons();
            setIsConfirmDialogOpen(false);
            setIsReopenDialogOpened(true);
          }
        } catch (error) {
          console.log(error);
        }
      } else if (confirmDialogAction === "removePayment") {
        // console.log(`objectToAction.new_doc_status ${objectToAction.new_doc_status}`)
        try {
          await newRequest.post(
            "/cmClaim/delPmt",
            {
              claim_docid: claimDocId,
              payment_docid: objectToAction.object_id
            }
          );
          await fetchClaim();
          showToast(`Payment removed`, "success");
        } catch (error) {
          console.log(error);
        }
      } else if (confirmDialogAction === "generatePayment") {
        try {
          setIsProcessing(true);
          await newRequest.post("/cmReserve/reservePayment", { reserve_docid: objectToAction.object_id });
          await fetchClaim();
          setIsProcessing(false);
          showToast(`Payment generated`, "success");
        } catch (error) {
          console.log(error);
        } finally {
          setIsProcessing(false);
        }
      }
    } catch (err) {
      console.log(err);
    }
    // Close the dialog
    setIsConfirmDialogOpen(false);
  };


  const saveRecord = async (e) => {
    try {
      if (!cmDescription) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Please enter description!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (!cmLossDate) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Loss Date is Mandatory!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      if (!cmIntimationDate) {
        setNotifyDialogTitle("Note!");
        setNotifyDialogText(`Intimation date is mandatory!`);
        setIsNotifyDialogOpen(true);
        return;
      }

      setIsLoading(true);
      // Simulate delay for 5 seconds
      // await new Promise((resolve) => setTimeout(resolve, 3000));

      await newRequest.put(
        `/cmClaim/upd/${claimDocId}`,
        {
          cm_claim_no: cmClaimNo,
          cm_description: cmDescription,
          cm_stage: cmStage.value,
          cm_loss_date: cmLossDate,
          cm_intimation_date: cmIntimationDate,
          cm_injury: cmInjury,
          cm_amount_fc: formatStringToNumberV2(cmAmountFc),
          cm_amount_lc: cmAmountLc,
          cm_latitude: cmLatitude,
          cm_longitude: cmLongitude,
          cm_place_name: cmPlaceName,
          cm_loss_area: cmLossArea?.value,

        }
      );

      setNotifyDialogTitle("Success!");
      setNotifyDialogText(`Claim updated`);
      setIsNotifyDialogOpen(true);
      setIsLoading(false);
    } catch (err) {
      setIsLoading(false);
      console.log(err);
    }
  };

  useEffect(() => {
    function handleClickOutside(event) {
      // for hiding actions menu
      if (actionsMenuRef.current && !actionsMenuRef.current.contains(event.target)) {
        setOpenOptions(false);
      }
    }

    // Add event listener
    document.addEventListener('mousedown', handleClickOutside);

    // Clean up the event listener
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  useEffect(() => {
    if (claimDocId) {
      fetchClaim(true);
    }
    fetchClaimStage();
    fetchGenders();
    fetchRiskAreas();
  }, [claimDocId]);

  // top menu 
  const handleTabClick = (index) => {
    setActiveTab(index);
  };

  const handleAnalyzeClaim = async () => {
    try {
      setIsProcessing(true);
      await newRequest.post("/cmRule/evaluateClaim",
        {
          claim_docid: claimDocId,
          sr_ref: "000"
        }
      );
      fetchClaim();
    } catch (error) {
      console.log(error)
    } finally {
      setIsProcessing(false);
    }
  };

  const handleGenerateClaimNo = async () => {
    try {
      setIsProcessing(true);
      const claimNo = await newRequest.post(
        "/numGen/genClaimNumber",
        {
          pr_code: claimData?.policy_xx?.pl_product_code,
          branch_code: claimData?.policy_xx?.pl_biz_unit,
          term_code: claimData?.policy_xx?.pl_term_code,
          trans_date: getTodaysDateWithoutTime()
        }
      );
      await newRequest.put(`/cmClaim/upd/${claimData?._id}`, { cm_claim_no: claimNo.data });
      await fetchClaim();
    } catch (error) {
      console.log(error)
    } finally {
      setIsProcessing(false);
    }
  };

  const [activeTab, setActiveTab] = useState(0);
  const topMenus = [
    {
      menu_key: "details",
      menu_title: "Details",
      menu_icon: <EventNoteIcon />,
      menu_count: 0,
    },
    {
      menu_key: "attachments",
      menu_title: "Attachments",
      menu_icon: <TopicIcon />,
      menu_count: attachmentsData.length,
    },
    {
      menu_key: "correspondence",
      menu_title: "Correspondence",
      menu_icon: <SubjectIcon />,
      menu_count: 0,
    },
    {
      menu_key: "comments",
      menu_title: "Comments",
      menu_icon: <CommentIcon />,
      menu_count: 0,
    }
  ];

  useEffect(() => {
    const compute = () => {
      const el = pageShellRef.current;
      if (!el) return;

      const rect = el.getBoundingClientRect();
      // how much “empty space” exists on the right side of the centered/max-width container
      const offset = Math.max(0, window.innerWidth - rect.right);
      setCollabRightOffset(offset);
    };

    compute();

    window.addEventListener("resize", compute);
    // optional: if your layout can shift on scroll due to sticky headers etc.
    window.addEventListener("scroll", compute, true);

    return () => {
      window.removeEventListener("resize", compute);
      window.removeEventListener("scroll", compute, true);
    };
  }, []);

  return (
    <motion.div
      className="cm-claim"
      initial={{ opacity: 0 }}
      animate={{ opacity: 1, transition: { duration: 1 } }}
      exit={{ opacity: 0, transition: { duration: 1 } }}
    >
      {isLoading ? (
        <div className="no-content">
            <ScaleLoader
            color="var(--primary)"
            height={50}
            radius={8}
            width={4}
          />
        </div>
      ) : (
        <div className="cm-claim-main-wrapper">
          <div className="navbar">
            <div className="navbar-left">
              <span className="page-title"> {claimData?.policy_xx?.insured_details_xx?.ent_name || t('new').toUpperCase()}</span>
              <span className="sub-title xrsmall" style={{ fontSize: "10px" }}>{`${claimData?.policy_xx?.product_name_xx} [${claimData?.policy_xx?.pl_product_code}]`}</span>
            </div>
            <div className="navbar-right">
              {documentEnabled === "Y" && (
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  borderRadiusType="both"
                  variant="tint"
                  color="#0f766e5d"
                  endIcon={<RefreshIcon />}
                  onClick={fetchClaim}>
                  {t('refresh')}
                </CustomLoadingButton>
              )}
              {documentEnabled === "Y" && (
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  borderRadiusType="both"
                  variant="tint"
                  color="#2563EB"
                  tooltip="Run reports for this document"
                  endIcon={<IoDocumentTextSharp />}
                  onClick={() => setReportsDialogOpen(true)}>
                  {t('reports')}
                </CustomLoadingButton>
              )}
              {documentEnabled === "Y" && (
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  borderRadiusType="both"
                  variant="tint"
                  color="#00D37F"
                  tooltip="Save changes"
                  endIcon={<FaSave />}
                  onClick={saveRecord}>
                  {t('save')}
                </CustomLoadingButton>
              )}
              {claimData?.length > 0 && (
                <CustomLoadingButton
                  currentTheme={currentTheme}
                  iconPosition="end"
                  borderRadiusType="both"
                  variant="tint"
                  color="#2563EB"
                  tooltip="Run reports for this document"
                  endIcon={<DescriptionIcon />}
                  width={"250px"}
                  onClick={async () => {
                    try {
                      await newRequest.post(
                        "/trace/add",
                        {
                          trc_action_on: "Document",
                          trc_doc_type: "claim",
                          trc_doc_no: claimData?.cm_our_ref,
                          trc_aent_code: "",
                          trc_ent_code: "",
                          trc_action: "previewed claim",
                          trc_remarks: `previewed claim ${claimData?.cm_our_ref}`,
                          trc_tags: ["previewed claim", claimData?.cm_our_ref],
                          trc_doc_docid: claimData?._id
                        }
                      );
                      navigate(`/rcpview/${claimData._id}`);
                    } catch (error) {
                      console.log(error);
                    }
                  }}
                >
                  {t('previewDocument')}
                </CustomLoadingButton>
              )}
              <CustomLoadingButton
                currentTheme={currentTheme}
                iconPosition="end"
                borderRadiusType="both"
                variant="tint"
                color="#f55656"
                tooltip="Close this document"
                endIcon={<MdClose />} onClick={() => navigate(-1)}>
                {t('close')}
              </CustomLoadingButton>
              {/* Additional Actions for priviledged users */}
              {["Opened"].includes(claimData?.cm_status) &&
                <div className="icon-container"
                  ref={actionsMenuRef}
                  onClick={(e) => {
                    try {
                      e.stopPropagation();
                      setOpenOptions(!openOptions)
                    } catch (error) {
                      console.log(error)
                    }
                  }}>
                  <MdOutlineMenuOpen className="icon" />
                  {openOptions && (
                    <div className="dropdown">
                      {["Opened"].includes(claimData?.cm_status) &&
                        <div className="dropdown-item"
                          onClick={() => {
                            try {
                              if (claimData?.cm_status === "Opened" && claimData?.total_os_amount_fc > 0) {
                                setNotifyDialogTitle("Note!");
                                setNotifyDialogText(`This claim has an outstanding amount of ${claimData?.currency_xx} ${numeral(claimData?.total_os_amount_fc).format("0,0.00")} hence you cannot close it. If you still want to close it, adjust the claim amount to the total paid!`);
                                setIsNotifyDialogOpen(true);
                                return;
                              }
                              if (claimData?.cm_status === "Opened" && claimData?.total_os_amount_fc < 0) {
                                setNotifyDialogTitle("Note!");
                                setNotifyDialogText(`This claim has has been overpaid by ${claimData?.currency_xx} ${numeral(claimData?.total_os_amount_fc).format("0,0.00")} hence you cannot close it. If you still want to close it, adjust the claim amount to the total paid!`);
                                setIsNotifyDialogOpen(true);
                                return;
                              }

                              let action_text = "";
                              let new_doc_status = claimData?.cm_status;
                              switch (claimData?.cm_status) {
                                case "Opened":
                                  action_text = `Do you want to close this claim?`;
                                  setInvokedAction("Close");
                                  new_doc_status = "Closed";
                                  break;
                                case "Closed":
                                  action_text = `Do you want to ReOpen this claim?`;
                                  setInvokedAction("Reopen");
                                  new_doc_status = "Opened";
                                  break;
                                default:
                                  action_text = "";
                                  new_doc_status = "";
                              }
                              setObjectToAction({
                                object_id: claimData._id,
                                action_text: action_text,
                                new_doc_status,
                              });
                              setConfirmDialogAction("claimAction");
                              setIsConfirmDialogOpen(true);
                            } catch (error) {
                              console.log(error);
                            }
                          }}
                        >{nextAction}</div>}
                      {["Opened"].includes(claimData?.cm_status) &&
                        <div className="dropdown-item"
                          onClick={handleAnalyzeClaim}
                        >{t('analyze')}</div>}
                      {["Opened"].includes(claimData?.cm_status) &&
                        <div className="dropdown-item"
                          onClick={handleGenerateClaimNo}
                        >{t('claimNo')}</div>}
                    </div>
                  )}
                </div>}
              {/* COLLABORATOR OPEN ACTION */}
              <div className="collaborator-icon"
                onClick={openCollab}>
                <MdForum className="icon" />
              </div>
            </div>
          </div>
          <div className="content-summary-wrapper">
            <div className="document-details-wrapper">
              <div className="tabs-container">
                <div className="tab-header">
                  {topMenus?.map((tab, index) => (
                    <div
                      key={index}
                      className={`${activeTab === index ? 'tab active' : 'tab'}`}
                      onClick={() => handleTabClick(index)}
                    >
                      <span className={`${activeTab === index ? 'tab-icon active' : 'tab-icon'}`}
                      >
                        {tab.menu_icon}
                      </span>
                      <span className={`${activeTab === index ? 'tab-title active' : 'tab-title'}`}>{tab.menu_title}</span>
                      {tab.menu_count > 0 && <Badge badgeContent={tab.menu_count} showZero
                        className="tab-badge" />}
                    </div>
                  ))}
                </div>
              </div>
              <div className="content-details">
                {/* Summary Information */}
                {activeTab === 0 &&
                  <motion.div
                    className="tabs-view-wrapper"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}>
                    {/* <div className="content-details-row">
                      <h1 className="main-title">CLIENT</h1>
                      <span className={`status ${cmStatus}`}>
                        {cmStatus}
                      </span>
                    </div> */}
                    {/* <div className="content-details-row"> */}
                    <ExpandableComponent
                      title={t('insured')}
                      subtitle={
                        <span className="sub-title">
                          {claimData?.policy_xx?.insured_details_xx?.ent_type === "Individual" &&
                            claimData?.policy_xx?.insured_details_xx?.ent_occupation_xx &&
                            <span className="sub-title">{`${t('occupation')} : ${claimData?.policy_xx?.insured_details_xx?.ent_occupation_xx}`}</span>
                          }
                          {claimData?.policy_xx?.insured_details_xx?.ent_type !== "Individual" &&
                            claimData?.policy_xx?.insured_details_xx?.ent_sub_sector_xx &&
                            <span className="sub-title">{`${t('sector')} : ${claimData?.policy_xx?.insured_details_xx?.ent_sector_xx} | ${claimData?.policy_xx?.insured_details_xx?.ent_sub_sector_xx}`}</span>
                          }
                        </span>
                      }
                      defaultExpanded={true}
                    >
                      <div className="content-details-row insured">
                        <motion.div
                          className="entity-details-container"
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1, transition: { duration: 1 } }}
                          exit={{ opacity: 0, transition: { duration: 1 } }}>
                          <div className="entity-details-wrapper">
                            <div className="entity-details-left">
                              {claimData?.policy_xx?.insured_details_xx?.ent_photo_url ?
                                <img src={claimData?.policy_xx?.insured_details_xx?.ent_photo_url} alt="" className="img" />
                                :
                                <InitialsAvatar
                                  name={claimData?.policy_xx?.insured_details_xx?.ent_name}
                                  size={60}
                                  currentTheme={currentTheme}
                                />}
                            </div>
                            <div className="entity-details-right">
                              <div className="name-row">
                                <span className="main-title"> {claimData?.policy_xx?.insured_details_xx?.ent_name}</span>
                              </div>
                              <div className="email-phone-row">
                                <span className="email-phone-details" style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    try {
                                      setEmailData({
                                        to: claimData?.policy_xx?.insured_details_xx?.ent_email,
                                        cc: '',
                                        bcc: '',
                                        subject: '',
                                        show_attach: "Y",
                                        attached_urls: [],
                                        binary_docs: [],
                                        doc_no: claimData?.cm_our_ref,
                                        doc_type: "Claim",
                                        doc_id: claimDocId,
                                        entity_codes: [claimData?.policy_xx?.insured_details_xx?.ent_code, claimData?.policy_xx?.carrier_details_xx?.ent_code],
                                        search_string: claimData?.policy_xx?.insured_details_xx?.ent_code + "," + claimData?.policy_xx?.carrier_details_xx?.ent_name + "," + claimData?.cm_our_ref + "," + cmClaimNo,
                                        carrierName: claimData?.policy_xx?.carrier_details_xx?.ent_name,
                                        productName: claimData?.policy_xx?.product_name_xx,
                                        clientName: claimData?.policy_xx?.insured_details_xx?.ent_code,
                                        riskNoteNo: cmRiskNoteNo,
                                        daysToRenewal: claimData?.expiring_in_days,
                                        expiryDate: claimData?.fmt_to_date,
                                        insuredName: claimData?.policy_xx?.insured_details_xx?.ent_name,
                                        outstandingPremium: claimData?.total_os_fc_amount,
                                        policyCurrency: claimData?.policy_xx?.currency_xx,
                                        policyNumber: cmPolicyNo,
                                        policyPremium: claimData?.fmt_policy_fc_prem,
                                        policyPremiumTotal: claimData?.fmt_total_fc_prem,
                                        policySumInsured: claimData?.fmt_total_fc_si,
                                        policyFromDate: claimData?.fmt_fm_date,
                                        policyToDate: claimData?.fmt_to_date,
                                        claimCurrentStage: cmStage?.label,
                                        claimDesc: cmDescription,
                                        claimIntimationDate: claimData?.fmt_intimation_date,
                                        claimLossDate: claimData?.fmt_loss_date,
                                        claimNo: claimData?.cm_claim_no,
                                        claimOurRef: claimData?.cm_our_ref,
                                        tpt_category: []
                                      });
                                      setEmailDialogOpen(true);
                                    } catch (error) {
                                      console.log(error)
                                    }
                                  }}>
                                  <MdAlternateEmail className="icon" /> <h1 className="sub-title">{claimData?.policy_xx?.insured_details_xx?.ent_email || t('unspecified')}</h1>
                                </span>
                                <span className="email-phone-details">
                                  <MdPhone className="icon" /> <h1 className="sub-title">{claimData?.policy_xx?.insured_details_xx?.ent_phone_no || t('unspecified')}</h1>
                                </span>
                                <span className="email-phone-details">
                                  <TbCertificate className="icon" /> <h1 className="sub-title">{claimData?.policy_xx?.insured_details_xx?.aent_name_xx || t('unspecified')}</h1>
                                </span>
                                <span className="email-phone-details"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    try {
                                      navigate(`/entity/${claimData?.policy_xx?.insured_details_xx?._id}`);
                                    } catch (error) {
                                      console.log(error);
                                    }
                                  }}>
                                  <TagIcon className="icon" /> <h1 className="sub-title">{claimData?.policy_xx?.insured_details_xx?.ent_code}</h1>
                                </span>
                              </div>
                            </div>
                          </div>
                        </motion.div>
                      </div>
                    </ExpandableComponent>
                    <ExpandableComponent
                      title={t('intermediary')}
                      subtitle={
                        <span className="sub-title">
                          {claimData?.policy_xx?.carrier_details_xx?.ent_type === "Individual" &&
                            claimData?.policy_xx?.carrier_details_xx?.ent_occupation_xx &&
                            <span className="sub-title">{`${t('occupation')} : ${claimData?.policy_xx?.carrier_details_xx?.ent_occupation_xx}`}</span>
                          }
                          {claimData?.policy_xx?.carrier_details_xx?.ent_type !== "Individual" &&
                            claimData?.policy_xx?.carrier_details_xx?.ent_sub_sector_xx &&
                            <span className="sub-title">{`${t('sector')} : ${claimData?.policy_xx?.carrier_details_xx?.ent_sector_xx} | ${claimData?.policy_xx?.carrier_details_xx?.ent_sub_sector_xx}`}</span>
                          }
                        </span>
                      }
                      defaultExpanded={true}
                    >
                      <div className="content-details-row insured">
                        <motion.div
                          className="entity-details-container"
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1, transition: { duration: 1 } }}
                          exit={{ opacity: 0, transition: { duration: 1 } }}>
                          <div className="entity-details-wrapper">
                            <div className="entity-details-left">
                              {claimData?.policy_xx?.carrier_details_xx?.ent_photo_url ?
                                <img src={claimData?.policy_xx?.carrier_details_xx?.ent_photo_url} alt="" className="img" />
                                :
                                <InitialsAvatar
                                  name={claimData?.policy_xx?.carrier_details_xx?.ent_name}
                                  size={60}
                                  currentTheme={currentTheme}
                                />}
                            </div>
                            <div className="entity-details-right">
                              <div className="name-row">
                                <span className="main-title"> {claimData?.policy_xx?.carrier_details_xx?.ent_name}  </span>
                              </div>
                              <div className="email-phone-row">
                                <span className="email-phone-details" style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    try {
                                      setEmailData({
                                        to: claimData?.policy_xx?.carrier_details_xx?.ent_email,
                                        cc: '',
                                        bcc: '',
                                        subject: '',
                                        show_attach: "Y",
                                        attached_urls: [],
                                        binary_docs: [],
                                        doc_no: claimData?.cm_our_ref,
                                        doc_type: "Claim",
                                        doc_id: claimDocId,
                                        entity_codes: [claimData?.policy_xx?.insured_details_xx?.ent_code, claimData?.policy_xx?.carrier_details_xx?.ent_code],
                                        search_string: claimData?.policy_xx?.insured_details_xx?.ent_code + "," + claimData?.policy_xx?.carrier_details_xx?.ent_name + "," + claimData?.cm_our_ref + "," + cmClaimNo,
                                        carrierName: claimData?.policy_xx?.carrier_details_xx?.ent_name,
                                        productName: claimData?.policy_xx?.product_name_xx,
                                        clientName: claimData?.policy_xx?.insured_details_xx?.ent_code,
                                        riskNoteNo: cmRiskNoteNo,
                                        daysToRenewal: claimData?.expiring_in_days,
                                        expiryDate: claimData?.fmt_to_date,
                                        insuredName: claimData?.policy_xx?.insured_details_xx?.ent_name,
                                        outstandingPremium: claimData?.total_os_fc_amount,
                                        policyCurrency: claimData?.policy_xx?.currency_xx,
                                        policyNumber: cmPolicyNo,
                                        policyPremium: claimData?.fmt_policy_fc_prem,
                                        policyPremiumTotal: claimData?.fmt_total_fc_prem,
                                        policySumInsured: claimData?.fmt_total_fc_si,
                                        policyFromDate: claimData?.fmt_fm_date,
                                        policyToDate: claimData?.fmt_to_date,
                                        claimCurrentStage: cmStage?.label,
                                        claimDesc: cmDescription,
                                        claimIntimationDate: claimData?.fmt_intimation_date,
                                        claimLossDate: claimData?.fmt_loss_date,
                                        claimNo: claimData?.cm_claim_no,
                                        claimOurRef: claimData?.cm_our_ref,
                                        tpt_category: []
                                      });
                                      setEmailDialogOpen(true);
                                    } catch (error) {
                                      console.log(error)
                                    }
                                  }}>
                                  <MdAlternateEmail className="icon" /> <h1 className="sub-title">{claimData?.policy_xx?.carrier_details_xx?.ent_email || t('unspecified')}</h1>
                                </span>
                                <span className="email-phone-details">
                                  <MdPhone className="icon" /> <h1 className="sub-title">{claimData?.policy_xx?.carrier_details_xx?.ent_phone_no || t('unspecified')}</h1>
                                </span>
                                <span className="email-phone-details">
                                  <TbCertificate className="icon" /> <h1 className="sub-title">{claimData?.policy_xx?.carrier_details_xx?.aent_name_xx || t('unspecified')}</h1>
                                </span>
                                <span className="email-phone-details"
                                  style={{ cursor: "pointer" }}
                                  onClick={() => {
                                    try {
                                      navigate(`/entity/${claimData?.policy_xx?.carrier_details_xx?._id}`);
                                    } catch (error) {
                                      console.log(error)
                                    }
                                  }}>
                                  <TagIcon className="icon" /> <h1 className="sub-title">{claimData?.policy_xx?.carrier_details_xx?.ent_code}</h1>
                                </span>
                              </div>
                            </div>
                          </div>
                        </motion.div>
                      </div>
                    </ExpandableComponent>

                    <ExpandableComponent
                      title={t('claimDetails').toUpperCase()}
                      subtitle={
                        <div className="input-item-with-label">
                          <label
                            htmlFor="current_stage_xx"
                            className="form-dropdown-label"
                            style={{ width: "100px" }}
                          >
                            {t('stage').toUpperCase()}
                          </label>
                          <Select
                            id="current_stage_xx"
                            name="current_stage_xx"
                            menuPortalTarget={document.body}
                            styles={{
                              ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                              menuPortal: base => ({
                                ...base,
                                zIndex: 9999,
                              })
                            }}
                            width="300px"
                            value={cmStage}
                            onChange={(selectedOption) => setCmStage(selectedOption)}
                            options={claimStages}
                            isSearchable={true}
                            placeholder={t('stage').toUpperCase()}
                            isDisabled={documentEnabled === "N"}
                          />
                        </div>}
                      defaultExpanded={true}
                    >
                      <motion.div
                        initial={{ opacity: 0 }}
                        animate={{ opacity: 1, transition: { duration: 1 } }}
                        exit={{ opacity: 0, transition: { duration: 1 } }}>


                        <div className="basis-of-claim">
                          <div className="two-column-row">
                            <div className="input-item-with-label">
                              <label
                                htmlFor="cm_claim_no"
                                className="form-dropdown-label"
                                style={{ width: "100px" }}
                              >
                                {t('claimNo').toUpperCase()}
                              </label>
                              <input
                                id="cm_claim_no"
                                name="cm_claim_no"
                                type="text"
                                disabled
                                value={claimData?.cm_claim_no || "-"}
                                className="form-input-item"
                                style={{ width: "180px" }}
                              />
                            </div>
                            <div className="input-item-with-label">
                              <label
                                htmlFor="product"
                                className="form-dropdown-label"
                                style={{ width: "100px" }}
                              >
                                {t('product').toUpperCase()}
                              </label>
                              <input
                                id="product"
                                name="product"
                                type="text"
                                disabled
                                defaultValue={claimData?.policy_xx?.product_name_xx || "-"}
                                className="form-input-item"
                                style={{ width: "170px" }}
                              />
                            </div>
                            <div className="input-item-with-label">
                              <label
                                htmlFor="currency"
                                className="form-dropdown-label"
                                style={{ width: "100px" }}
                              >
                                {t('currency').toUpperCase()}
                              </label>
                              <input
                                id="currency"
                                name="currency"
                                type="text"
                                disabled
                                defaultValue={claimData?.policy_xx?.currency_xx || "-"}
                                className="form-input-item"
                                style={{ width: "170px" }}
                              />
                            </div>
                          </div>
                        </div>
                        <div className="basis-of-claim">
                          <div className="two-column-row">
                            <div className="input-item-with-label">
                              <label
                                htmlFor="cm_policy_no"
                                className="form-dropdown-label"
                                style={{ width: "100px" }}
                              >
                                {t('policyNo').toUpperCase()}
                              </label>
                              <input
                                id="cm_policy_no"
                                name="cm_policy_no"
                                type="text"
                                disabled
                                defaultValue={claimData?.cm_policy_no || "-"}
                                className="form-input-item"
                                style={{ width: "180px" }}
                              />
                            </div>
                            <div className="input-item-with-label">
                              <label
                                htmlFor="bizUnit"
                                className="form-dropdown-label"
                                style={{ width: "100px" }}
                              >
                                {t('bizUnit').toUpperCase()}
                              </label>
                              <input
                                id="bizUnit"
                                name="bizUnit"
                                type="text"
                                disabled
                                defaultValue={claimData?.policy_xx?.bizunit_name_xx || "-"}
                                className="form-input-item"
                                style={{ width: "170px" }}
                              />
                            </div>
                            <div className="input-item-with-label">
                              <label
                                htmlFor="cm_our_ref"
                                className="form-dropdown-label"
                                style={{ width: "100px" }}
                              >
                                {t('ourRef').toUpperCase()}
                              </label>
                              <input
                                id="cm_our_ref"
                                name="cm_our_ref"
                                type="text"
                                disabled
                                defaultValue={claimData?.cm_our_ref || "-"}
                                className="form-input-item"
                                style={{ width: "170px" }}
                              />
                            </div>
                          </div>
                        </div>

                        <h1 className="main-title" style={{ margin: "10px 0px" }}> {t('importantDates').toUpperCase()}</h1>
                        <div className="basis-of-claim">
                          <div className="two-column-row">
                            <div className="input-item-with-label">
                              <label
                                htmlFor="riskToDateXx"
                                className="form-dropdown-label"
                                style={{ width: "100px" }}
                              >
                                {t('intimation').toUpperCase()}
                              </label>
                              <input
                                id="cm_intimation_date"
                                name="cm_intimation_date"
                                type="date"
                                disabled={documentEnabled === "N"}
                                value={cmIntimationDate}
                                className="form-input-item"
                                style={{ width: "180px" }}
                                onChange={(e) => setCmIntimationDate(e.target.value)}
                              />
                            </div>
                            <div className="input-item-with-label">
                              <label
                                htmlFor="riskFmDateXx"
                                className="form-dropdown-label"
                                style={{ width: "100px" }}
                              >
                                {t('coverFrom').toUpperCase()}
                              </label>
                              <input
                                id="riskFmDateXx"
                                name="riskFmDateXx"
                                type="text"
                                placeholder="FROM"
                                disabled
                                defaultValue={claimData?.risk_details_xx?.risk_fm_date_xx}
                                className="form-input-item"
                                style={{ width: "170px" }}
                              />
                            </div>
                            <div className="input-item-with-label">
                              <label
                                htmlFor="createdDate"
                                className="form-dropdown-label"
                                style={{ width: "100px" }}
                              >
                                {t('created').toUpperCase()}
                              </label>
                              <input
                                id="createdDate"
                                name="createdDate"
                                type="text"
                                placeholder="FROM"
                                disabled
                                defaultValue={createdDate}
                                className="form-input-item"
                                style={{ width: "170px" }}
                              />
                            </div>
                          </div>

                          <div className="two-column-row" style={{ marginTop: "10px" }}>
                            <div className="input-item-with-label">
                              <label
                                htmlFor="cm_loss_date"
                                className="form-dropdown-label"
                                style={{ width: "100px" }}
                              >
                                {t('lossDate').toUpperCase()}
                              </label>
                              <input
                                id="cm_loss_date"
                                name="cm_loss_date"
                                type="date"
                                disabled={documentEnabled === "N"}
                                value={cmLossDate}
                                className="form-input-item"
                                style={{ width: "180px" }}
                                onChange={(e) => setCmLossDate(e.target.value)}
                              />
                            </div>
                            <div className="input-item-with-label">
                              <label
                                htmlFor="riskToDateXx"
                                className="form-dropdown-label"
                                style={{ width: "100px" }}
                              >
                                {t('coverTo').toUpperCase()}
                              </label>
                              <input
                                id="riskToDateXx"
                                name="riskToDateXx"
                                type="text"
                                disabled
                                defaultValue={claimData?.risk_details_xx?.risk_to_date_xx}
                                className="form-input-item"
                                style={{ width: "170px" }}
                              />
                            </div>
                            <div className="input-item-with-label">
                              <label
                                htmlFor="time_ago_xx"
                                className="form-dropdown-label"
                                style={{ width: "100px" }}
                              >
                                {t('updated').toUpperCase()}
                              </label>
                              <input
                                id="time_ago_xx"
                                name="time_ago_xx"
                                type="text"
                                placeholder="UPDATED"
                                disabled
                                defaultValue={claimData?.time_ago_xx}
                                className="form-input-item"
                                style={{ width: "170px" }}
                              />
                            </div>
                          </div>
                        </div>

                        <div className="input-item-with-label" style={{ marginTop: "5px", width: "100%" }}>
                          <label
                            htmlFor="cm_description"
                            className="form-dropdown-label"
                            style={{ width: "115px", alignSelf: "flex-start" }}
                          >
                            {t('narration').toUpperCase()}
                          </label>
                          <textarea
                            id="cm_description"
                            name="cm_description"
                            type="text"
                            placeholder="NARRATION"
                            value={cmDescription}
                            row={5}
                            className="form-input-item"
                            style={{ width: "100%" }}
                            onChange={(e) => setCmDescription(e.target.value)}
                            disabled={documentEnabled === "N"}
                          />
                        </div>

                        <div className="basis-of-claim">
                          <div className="input-item-with-label" style={{ width: "100%" }}>
                            <label
                              htmlFor="place"
                              className="form-dropdown-label"
                              style={{ width: "110px" }}
                            >
                              {t('place').toUpperCase()}
                            </label>
                            <div style={{ display: "flex", flexDirection: "row", alignItems: "center", justifyContent: "space-between", width: "100%", gap: "10px" }}>
                              <div style={{ display: "flex", flex: "1", flexDirection: "row", alignItems: "center", gap: "10px" }}>
                                <span className='normal-title'>{cmPlaceName || t('notSelected').toUpperCase()}</span>
                                {claimData?.cm_status === "Opened" &&
                                  <CircularButton
                                    currentTheme={currentTheme}
                                    onClick={(e) => setPlacesDialogOpen(true)}
                                    icon={<IoLocationSharp color="green" />}
                                    width={"30px"}
                                    height={"30px"} />}
                              </div>
                              <div className='google-place-wrapper' onClick={() => {
                                if (cmLatitude && cmLongitude) { handleOpenMap(cmLatitude, cmLongitude) }
                              }}>
                                <span className='normal-title'>{`${t('latitude')} ${cmLatitude || ""}`}</span>
                                <span className='normal-title'>{`${t('longitude')} ${cmLongitude || ""}`}</span>
                              </div>
                            </div>
                          </div>
                        </div>

                        <div className="basis-of-claim">
                          <h1 className="normal-title">{`BASIS OF CLAIM SETTLEMENT ${basisOfClaimXx?.length === 0 ? "NOT SPECIFIED" : ""}`}</h1>
                          {/* basis of claim text */}
                          {basisOfClaimXx?.length > 0 && (
                            <div>
                              {basisOfClaimXx?.map((claim, index) => (
                                <div key={claim._id}>
                                  <div className="single-basis-row">
                                    <span style={{ alignContent: "flex-start" }}> {index + 1}. </span>
                                    <span style={{ fontWeight: "500", fontSize: "16px", }}>{`${claim.basis_text}`}</span>
                                  </div>
                                </div>
                              ))}
                            </div>
                          )}
                        </div>
                      </motion.div>
                    </ExpandableComponent>
                    {/* Only shown if claim has intermediary */}
                    {claimData?.carrier_details_xx?.ent_name &&
                      <ExpandableComponent
                        title={t('intermediary').toUpperCase()}
                        subtitle=""
                        defaultExpanded={claimData?.carrier_details_xx?.ent_name ? true : false}
                      >
                        <div className="content-details-row carrier">
                          <motion.div
                            className="entity-details-container"
                            initial={{ opacity: 0 }}
                            animate={{ opacity: 1, transition: { duration: 1 } }}
                            exit={{ opacity: 0, transition: { duration: 1 } }}>
                            <div className="entity-details-wrapper">
                              <div className="entity-details-left">
                                {claimData?.carrier_details_xx?.ent_photo_url ?
                                  <img src={claimData?.carrier_details_xx?.ent_photo_url} alt="" className="img" />
                                  :
                                  <InitialsAvatar
                                    name={claimData?.carrier_details_xx?.ent_name}
                                    size={80}
                                    currentTheme={currentTheme}
                                  />}
                              </div>
                              <div className="entity-details-right">
                                <div className="name-row">
                                  <h1 className="main-title">
                                    {claimData?.carrier_details_xx?.ent_name}
                                  </h1>
                                  <h1 className="main-title">
                                    {claimData?.carrier_details_xx?.ent_occupation_xx}
                                  </h1>
                                  <h1 className="main-title">
                                    {claimData?.carrier_details_xx?.ent_name}
                                  </h1>
                                </div>
                                <div className="email-phone-row">
                                  <span className="email-phone-details" style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      try {
                                        setEmailData({
                                          to: claimData?.policy_xx?.insured_details_xx?.ent_email,
                                          cc: '',
                                          bcc: '',
                                          subject: `CLAIM NO ${cmClaimNo}`,
                                          show_attach: "Y",
                                          attached_urls: [],
                                          binary_docs: [],
                                          doc_no: cmClaimNo,
                                          doc_type: "Claim",
                                          doc_id: claimDocId,
                                          entity_codes: [claimData?.policy_xx?.insured_details_xx?.ent_code, claimData?.carrier_details_xx?.ent_code],
                                          search_string: claimData?.policy_xx?.insured_details_xx?.ent_name + "," + claimData?.carrier_details_xx?.ent_name + "," + cmClaimNo,
                                          carrierName: claimData?.carrier_details_xx?.ent_name,
                                          productName: claimData?.product_name_xx,
                                          clientName: claimData?.policy_xx?.insured_details_xx?.ent_name,
                                          riskNoteNo: cmClaimNo,
                                          daysToRenewal: "0",
                                          expiryDate: null,
                                          insuredName: claimData?.policy_xx?.insured_details_xx?.label,
                                          outstandingPremium: 0,
                                          policyCurrency: claimData?.currency_xx,
                                          policyNumber: cmClaimNo,
                                          policyPremium: 0,
                                          policyPremiumTotal: 0,
                                          policySumInsured: 0,
                                          policyFromDate: null,
                                          policyToDate: null,
                                          tpt_category: []
                                        });
                                        setEmailDialogOpen(true);
                                      } catch (error) {
                                        console.log(error)
                                      }
                                    }}>
                                    <MdAlternateEmail className="icon" /> <h1 className="sub-title">{claimData?.carrier_details_xx?.ent_email || ""}</h1>
                                  </span>
                                  <span className="email-phone-details">
                                    <MdPhone className="icon" /> <h1 className="sub-title">{claimData?.carrier_details_xx?.ent_phone_no || ""}</h1>
                                  </span>
                                  <span className="email-phone-details">
                                    <TbCertificate className="icon" /> <h1 className="sub-title">{claimData?.carrier_details_xx?.aent_name_xx || ""}</h1>
                                  </span>
                                  <span className="email-phone-details"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => {
                                      try {
                                        navigate(`/entity/${claimData?.carrier_details_xx?._id}`, {
                                          state: { shouldFetchClients: false },
                                        });
                                      } catch (error) {
                                        console.log(error)
                                      }
                                    }}>
                                    <TagIcon className="icon" /> <h1 className="sub-title">{claimData?.carrier_details_xx?.ent_code || ""}</h1>
                                  </span>
                                </div>
                                {/* <div className="email-phone-row" style={{ flexDirection: "row", gap: "5px", justifyContent: "flex-end" }}>
                            GMO
                          </div> */}
                              </div>
                            </div>
                          </motion.div>
                        </div>
                      </ExpandableComponent>}
                    {/* particulars */}
                    <ExpandableComponent
                      title={["term life", "whole life"].includes(claimData?.policy_xx?.product_type_xx)
                        ? `${t('insuredLife').toUpperCase()}`
                        :
                        reserveView === "reserve-details" ? `${t('reserveDetails').toUpperCase()}` : `${t('riskItem').toUpperCase()}`
                      }
                      subtitle={
                        <>
                          {reserveView === "reserve-details" &&
                            <CustomLoadingButton
                              currentTheme={currentTheme}
                              iconPosition="end"
                              borderRadiusType="both"
                              variant="tint"
                              color="#0ea5a4"
                              height={"32px"}
                              tooltip={"Back to reserves"}
                              endIcon={<LuLayoutList />}
                              onClick={() => {
                                try {
                                  setSelectedReserveAction(null);
                                  setReserveView("reserves");
                                } catch (error) {
                                  console.log(error);
                                }
                              }}
                            >
                              {t('viewAllReserves')}
                            </CustomLoadingButton>}
                          {reserveView === "reserves" &&
                            claimData?.cm_status !== "Closed" &&
                            <CustomLoadingButton
                              currentTheme={currentTheme}
                              iconPosition="end"
                              borderRadiusType="both"
                              variant="tint"
                              color="#0ea5a4"
                              tooltip={"Add new reserve"}
                              endIcon={<MdAdd />}
                              onClick={() => {
                                try {
                                  setReserveAmountFc(null);
                                  setTypes();
                                  setReserveType({
                                    value: "Own Damage",
                                    label: capitalizeFirstLetter("Own Damage"),
                                  });
                                  setReserveDesc("");
                                  setReserveEntity(null);
                                  setReserveAction("add");
                                  setIsReserveOpened(!isReserveOpened);
                                } catch (error) {
                                  console.log(error)
                                }
                              }}
                            >
                              {t('addReserve')}
                            </CustomLoadingButton>}
                        </>
                      }
                      defaultExpanded={true}
                    >
                      {/* this view if for non life policy claims */}
                      {!["term life", "whole life"].includes(claimData?.policy_xx?.product_type_xx) &&
                        reserveView === "reserves" &&
                        <motion.div
                          className="two-column-row" style={{ margin: "10px 0px" }}
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1, transition: { duration: 1 } }}
                          exit={{ opacity: 0, transition: { duration: 1 } }}>
                          <div className="single-cover current">
                            <div className="single-cover-title">
                              <span>{cmRiskCode}</span>
                              <span
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                }}
                              >
                                <span>{`Total Loss ${cmRiskTotalLoss}`}</span>
                              </span>
                            </div>
                            <div className="single-cover-desc">{claimData?.risk_description_xx}</div>
                          </div>
                          <div className="single-cover current">
                            <div className="single-cover-title">
                              <span>{claimData?.cover_name_xx}</span>
                              <span
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  gap: "10px",
                                }}
                              >
                                <span>{cmCoverCode}</span>
                              </span>
                            </div>
                            <div className="single-cover-desc">
                              {claimData?.cover_description_xx}
                            </div>
                          </div>
                        </motion.div>}
                      {/* end of non life policy claims */}
                      {/* this view is for life policy claims */}
                      {["term life", "whole life"].includes(claimData?.policy_xx?.product_type_xx) &&
                        <motion.div
                          style={{ display: "flex", flexDirection: "column", marginTop: "10px", gap: "10px" }}
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1, transition: { duration: 1 } }}
                          exit={{ opacity: 0, transition: { duration: 1 } }}>
                          <div className="risk-details-container">
                            <div className="risk-details-wrapper">
                              <div className="risk-details-left">
                                {claimData?.risk_details_xx?.risk_entity_xx?.ent_photo_url ?
                                  <img src={claimData?.risk_details_xx?.risk_entity_xx?.ent_photo_url} alt="" className="img" />
                                  :
                                  <InitialsAvatar
                                    name={claimData?.risk_details_xx?.risk_entity_xx?.ent_name}
                                    size={80}
                                    currentTheme={currentTheme}
                                  />}
                              </div>
                              <div className="risk-details-right">
                                <div className="name-row">
                                  <h1 className="main-title" style={{ color: "#181A20" }}>
                                    {claimData?.risk_details_xx?.risk_entity_xx?.ent_name}
                                  </h1>
                                  <div className="age-wrapper">
                                    <h1 className="sub-title" style={{ color: "#181A20" }}>{`${t('dateOfBirth')} ${claimData?.risk_details_xx?.risk_entity_xx?.formatted_dob || ""}`}</h1>
                                    <h1 className="sub-title" style={{ color: "#181A20" }}>{`${t('ageNextBirthday')} ${claimData?.risk_details_xx?.risk_entity_xx?.ent_nextage_xx || ""}`}</h1>
                                  </div>
                                </div>
                                <div className="email-phone-row">
                                  <span className="email-phone-details">
                                    <MdAlternateEmail className="icon" /> <h1 className="sub-title" style={{ color: "#181A20" }}>{claimData?.risk_details_xx?.risk_entity_xx?.ent_email || ""}</h1>
                                  </span>
                                  <span className="email-phone-details">
                                    <MdPhone className="icon" /> <h1 className="sub-title" style={{ color: "#181A20" }}>{claimData?.risk_details_xx?.risk_entity_xx?.ent_phone_no || ""}</h1>
                                  </span>
                                  <span className="email-phone-details">
                                    <TbCertificate className="icon" /> <h1 className="sub-title" style={{ color: "#181A20" }}>{claimData?.risk_details_xx?.risk_entity_xx?.ent_type || ""}</h1>
                                  </span>
                                  <span className="email-phone-details"
                                    style={{ cursor: "pointer" }}
                                    onClick={() => navigate(`/entity/${claimData?.risk_details_xx?.risk_entity_xx?._id}`)}>
                                    <TagIcon className="icon" /> <h1 className="sub-title" style={{ color: "#181A20" }}>{claimData?.risk_details_xx?.risk_entity_xx?.ent_code}</h1>
                                  </span>
                                </div>
                                <div className="email-phone-row">
                                  <span className="email-phone-details">
                                    <BsSuitcaseLgFill className="icon" /> <h1 className="sub-title" style={{ color: "#181A20" }}>{`${t('occupation').toUpperCase()}: ${claimData?.risk_details_xx?.risk_entity_xx?.ent_occupation_xx || ""}`}</h1>
                                  </span>
                                  <span className="email-phone-details">
                                    <MdOutlineSmokeFree className="icon" /> <h1 className="sub-title" style={{ color: "#181A20" }}>{`${claimData?.risk_details_xx?.risk_entity_xx?.smoke_flag_xx || ""}`}</h1>
                                  </span>
                                  <span className="email-phone-details">
                                    <MdGroupWork className="icon" /> <h1 className="sub-title" style={{ color: "#181A20" }}>{`${t('catg').toUpperCase()}: ${claimData?.risk_details_xx?.risk_entity_xx?.aent_name_xx || ""}`}</h1>
                                  </span>
                                  <span className="email-phone-details">
                                    <GrStatusCriticalSmall className="icon" /> <h1 className="sub-title" style={{ color: "#181A20" }}>{claimData?.risk_details_xx?.risk_entity_xx?.ent_status || ""}</h1>
                                  </span>
                                </div>
                              </div>
                            </div>
                          </div>
                          {claimData?.policy_xx?.pl_term_code_xx?.term_joint_type !== "none" &&
                            <h1 className="main-title" style={{ fontSize: "16px" }}>{`${t('jointInsuredLife').toUpperCase()}`}</h1>}
                          {claimData?.policy_xx?.pl_term_code_xx?.term_joint_type !== "none" &&
                            <div className="risk-details-container">
                              <div className="risk-details-wrapper">
                                <div className="risk-details-left">
                                  {claimData?.risk_details_xx?.risk_entity_joint_xx?.ent_photo_url ?
                                    <img src={claimData?.risk_details_xx?.risk_entity_joint_xx?.ent_photo_url} alt="" className="img" />
                                    :
                                    <InitialsAvatar
                                      name={claimData?.risk_details_xx?.risk_entity_joint_xx?.ent_name}
                                      size={80}
                                      currentTheme={currentTheme}
                                    />}
                                </div>
                                <div className="risk-details-right">
                                  <div className="name-row">
                                    <h1 className="main-title" style={{ color: "#181A20" }}>
                                      {claimData?.risk_details_xx?.risk_entity_joint_xx?.ent_name}
                                    </h1>
                                    <div className="age-wrapper">
                                      <h1 className="sub-title" style={{ color: "#181A20" }}>{`${t('dateOfBirth')} ${claimData?.risk_details_xx?.risk_entity_joint_xx?.formatted_dob || ""}`}</h1>
                                      <h1 className="sub-title" style={{ color: "#181A20" }}>{`${t('ageNextBirthday')} ${claimData?.risk_details_xx?.risk_entity_joint_xx?.ent_nextage_xx || ""}`}</h1>
                                    </div>
                                  </div>
                                  <div className="email-phone-row">
                                    <span className="email-phone-details">
                                      <MdAlternateEmail className="icon" /> <h1 className="sub-title" style={{ color: "#181A20" }}>{claimData?.risk_details_xx?.risk_entity_joint_xx?.ent_email || ""}</h1>
                                    </span>
                                    <span className="email-phone-details">
                                      <MdPhone className="icon" /> <h1 className="sub-title" style={{ color: "#181A20" }}>{claimData?.risk_details_xx?.risk_entity_joint_xx?.ent_phone_no || ""}</h1>
                                    </span>
                                    <span className="email-phone-details">
                                      <TbCertificate className="icon" /> <h1 className="sub-title" style={{ color: "#181A20" }}>{claimData?.risk_details_xx?.risk_entity_joint_xx?.ent_type || ""}</h1>
                                    </span>
                                    <span className="email-phone-details"
                                      style={{ cursor: "pointer" }}
                                      onClick={() => navigate(`/entity/${claimData?.risk_details_xx?.risk_entity_joint_xx?._id}`)}>
                                      <TagIcon className="icon" /> <h1 className="sub-title" style={{ color: "#181A20" }}>{claimData?.risk_details_xx?.risk_entity_joint_xx?.ent_code}</h1>
                                    </span>
                                  </div>
                                  <div className="email-phone-row">
                                    <span className="email-phone-details">
                                      <BsSuitcaseLgFill className="icon" /> <h1 className="sub-title" style={{ color: "#181A20" }}>{`${t('occupation').toUpperCase()}: ${claimData?.risk_details_xx?.risk_entity_joint_xx?.ent_occupation_xx || ""}`}</h1>
                                    </span>
                                    <span className="email-phone-details">
                                      <MdOutlineSmokeFree className="icon" /> <h1 className="sub-title" style={{ color: "#181A20" }}>{`${t('smoke')}: ${claimData?.risk_details_xx?.risk_entity_joint_xx?.smoke_flag_xx || ""}`}</h1>
                                    </span>
                                    <span className="email-phone-details">
                                      <MdGroupWork className="icon" /> <h1 className="sub-title" style={{ color: "#181A20" }}>{`${t('catg')}: ${claimData?.risk_details_xx?.risk_entity_joint_xx?.aent_name_xx || ""}`}</h1>
                                    </span>
                                    <span className="email-phone-details">
                                      <GrStatusCriticalSmall className="icon" /> <h1 className="sub-title" style={{ color: "#181A20" }}>{claimData?.risk_details_xx?.risk_entity_joint_xx?.ent_status || ""}</h1>
                                    </span>
                                  </div>
                                </div>
                              </div>
                            </div>}
                        </motion.div>}
                      {/* end of life policy claims */}

                      {reserveView === "reserves" &&
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", marginBottom: "5px" }}>
                          <h1 className="normal-title">{t('reserves').toUpperCase()}</h1>
                        </div>}
                      {/* reserves */}
                      {reserveView === "reserves" &&
                        <motion.div className="table-content"
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1, transition: { duration: 1 } }}
                          exit={{ opacity: 0, transition: { duration: 1 } }}>
                          <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                            <Table sx={{ width: "max-content", border: 'none' }}>
                              <TableBody className="tablebody">
                                {slicedReserves?.map((row, index) => (
                                  <div
                                    className={`${selectedReserve?._id === row._id ? "reserve-card current" : "reserve-card"}`}
                                    key={row?._id}
                                    onClick={() => {
                                      try {
                                        setSelectedReserve(row);
                                        setSelectedReserveMovement(null);
                                        setSelectedReserveMovement(row?.cr_movement_xx);
                                      } catch (error) {
                                        console.log(error);
                                      }
                                    }}>
                                    <div className="reserve-card-top">
                                      <div className="reserve-card-badges">
                                        <span className="reserve-pill priority--critical">{currentPage * rowsPerPage + index + 1}</span>
                                        {row.cr_type === "Own Damage" && <span className="reserve-pill priority--od">{row.cr_type}</span>}
                                        {row.cr_type === "Service Provider" && <span className="reserve-pill priority--sp">{row.cr_type}</span>}
                                        {row.cr_type === "Third Party" && <span className="reserve-pill priority--tp">{row.cr_type}</span>}
                                      </div>

                                      <div className={`reserve-status ${row.cr_status}`}>
                                        <span className={`reserve-status-dot dot--green`} />
                                        <span className="reserve-status-text">{row.cr_status}</span>
                                      </div>
                                    </div>

                                    <div className="reserve-card-body">
                                      <div className="reserve-main">

                                        {row.cr_type === "Own Damage" && <>
                                          <div className="reserve-title">{claimData?.policy_xx?.insured_details_xx?.ent_name || ""}</div>
                                          <div className="reserve-desc">{row?.cr_description || "-"}</div>
                                        </>}

                                        {row.cr_type === "Service Provider" && <>
                                          <div className="reserve-title">{row?.entity_xx?.ent_name || ""}</div>
                                          <div className="reserve-desc">{row?.cr_description || "-"}</div>
                                        </>}

                                        {row.cr_type === "Third Party" && <>
                                          <div className="reserve-desc">{row?.cr_description || "-"}</div>
                                        </>}

                                        <div className="reserve-meta">
                                          <div className="reserve-meta-item">
                                            <Avatar name={row?.updated_by_name_xx} photo={row?.updated_by_photo_url_xx} size={28} />
                                            <span className="reserve-meta-label">
                                              {t('lastUpdatedBy')}:{" "}
                                              <span className="reserve-meta-strong">
                                                {row?.updated_by_name_xx ? row.updated_by_name_xx : "Unassigned"}
                                              </span>
                                            </span>
                                          </div>

                                          <div className="reserve-meta-item reserve-meta-item--time">
                                            <span className="reserve-clock" />
                                            <span className="reserve-meta-label"> {row?.updated_ago_xx}</span>
                                          </div>
                                        </div>
                                      </div>

                                      <div className="reserve-side">
                                        <div className="reserve-sla">
                                          <div className="reserve-sla-top">
                                            <div className="sub-title">{t('currentReserve')?.toUpperCase()}</div>
                                            <div className="reserve-title">{numeral(row.cr_amount_fc).format("0,0.00")}</div>
                                          </div>
                                        </div>
                                        <div style={{ display: "flex", flexDirection: "row", gap: "10px" }}>
                                          <button
                                            className="reserve-link"
                                            onClick={() => {
                                              try {
                                                setSelectedReserve(row);
                                                setReserveAmountFc(formatNumber(row.cr_amount_fc, 2));
                                                setTypes();
                                                setReserveType({
                                                  value: row?.cr_type,
                                                  label: capitalizeFirstLetter(row?.cr_type),
                                                });
                                                setReserveEntity({
                                                  value: row?.cr_ent_code,
                                                  label: row?.entity_xx?.ent_name,
                                                });
                                                setReserveDesc(row.cr_description);
                                                setReserveId(row._id);
                                                setReserveAction("edit");
                                                setIsReserveOpened(!isReserveOpened)
                                              } catch (error) {
                                                console.log(error)
                                              }
                                            }}
                                          >
                                            <span className="reserve-link-arrow"><MdEdit /> </span>
                                            {t('edit')}
                                          </button>
                                          <button
                                            className="reserve-link"
                                            onClick={() => {
                                              try {
                                                setSelectedReserve(row);
                                                const beneficiaryCount = claimData?.risk_details_xx?.primary_beneficiaries_xx?.beneficiaries.length;
                                                const beneficiaryList = claimData?.risk_details_xx?.primary_beneficiaries_xx?.beneficiaries
                                                  .map(
                                                    (ben) =>
                                                      `<li>${ben.beneficiary_name} (${ben.ben_relationship}) - ${ben.ben_percentage}% [${claimData?.policy_xx?.currency_xx} - ${calculatePercentage(row.cr_amount_fc, ben.ben_percentage)}]</li>`
                                                  )
                                                  .join("");

                                                let action_text = "";
                                                if (beneficiaryCount === 1) {
                                                  action_text = `
                                                  Do you want to generate <strong>payment totaling ${claimData?.policy_xx?.currency_xx} ${numeral(row.cr_amount_fc).format("0,0.00")}</strong> for this reserve?<br/><br/>
                                                  Please note the payment will be generated as follows:<br/><br/>
                                                  <ol>${beneficiaryList}</ol><br/>
                                                  Please also note that ${claimData?.risk_details_xx?.risk_entity_xx?.ent_name} status will be changed to <strong>Deceased</strong>
                                                `;
                                                } else {
                                                  action_text = `
                                                  Do you want to generate <strong>${beneficiaryCount} payments totaling ${claimData?.policy_xx?.currency_xx} ${numeral(row.cr_amount_fc).format("0,0.00")}</strong> for this reserve?<br/><br/>
                                                  Please note the payments will be generated as follows:<br/><br/>
                                                  <ol>${beneficiaryList}</ol><br/>
                                                  Please also note that ${claimData?.risk_details_xx?.risk_entity_xx?.ent_name} status will be changed to <strong>Deceased</strong>
                                                `;
                                                }
                                                setObjectToAction({
                                                  object_id: row._id,
                                                  action_text: action_text,
                                                  new_doc_status: "generatePayment",
                                                });
                                                setConfirmDialogAction("generatePayment");
                                                setIsConfirmDialogOpen(true);
                                              } catch (error) {
                                                console.log(error);
                                              }
                                            }}
                                          >
                                            <span className="reserve-link-arrow"><MdOutlinePayments /></span>
                                            {t('pay')}
                                          </button>
                                          <button
                                            className="reserve-link"
                                            onClick={async () => {
                                              try {
                                                setSelectedReserve(row);
                                                setSelectedReserveMovement(null);
                                                setSelectedReserveMovement(row?.cr_movement_xx);
                                                setReserveView("reserve-details");
                                                setSelectedIndex(currentPage * rowsPerPage + index + 1);
                                                // set attachements for the reserve
                                                await fetchReserveAttachments("claim-reserve", row._id);
                                              } catch (error) {
                                                console.log(error)
                                              }
                                            }}
                                          >
                                            <span className="reserve-link-arrow"><LuListTree /> </span>
                                            {t('details')}
                                          </button>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </TableBody>
                            </Table>
                            {reserves?.length >
                              rowsPerPage &&
                              <TablePagination
                                rowsPerPageOptions={[5]}
                                rowsPerPage={rowsPerPage}
                                onRowsPerPageChange={handleRowsPerPage}
                                component="div"
                                count={reserves?.length}
                                rows={reserves}
                                page={currentPage}
                                onPageChange={handlePageChange}
                              />}
                          </TableContainer>
                        </motion.div>}
                      {reserveView === "beneficiary" &&
                        <div style={{ display: "flex", flexDirection: "row", justifyContent: "space-between", alignItems: "center", marginBottom: "5px" }}>
                          <h1 className="normal-title">{t('beneficiaries').toUpperCase()}</h1>
                          <span>
                            <CustomLoadingButton
                              currentTheme={currentTheme}
                              iconPosition="end"
                              borderRadiusType="both"
                              variant="tint"
                              color="#0ea5a4"
                              tooltip={"Back to reserves"}
                              endIcon={<LuLayoutList />}
                              onClick={() => setReserveView("reserves")}
                            >
                              {t('viewReserves')}
                            </CustomLoadingButton>
                          </span>
                        </div>}
                      {reserveView === "beneficiary" &&
                        <motion.div
                          className="beneficiaries"
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1, transition: { duration: 1 } }}
                          exit={{ opacity: 0, transition: { duration: 1 } }}>
                          <div className="beneficiaries-wrapper">
                            {/* <div className="beneficiaries-navbar">beneficiaries-navbar</div> */}
                            <div className="beneficiaries-content">
                              <div className="beneficiaries-list">
                                {claimData?.risk_details_xx?.primary_beneficiaries_xx?.beneficiaries?.map((row, index) => (
                                  <div key={row._id} className='single-beneficiary'>
                                    <div className="single-beneficiary-left">
                                      {row?.beneficiary_photo_url ?
                                        <img src={row?.beneficiary_photo_url} alt="" className="img" />
                                        :
                                        <InitialsAvatar
                                          name={row.beneficiary_name}
                                          size={60}
                                          currentTheme={currentTheme}
                                        />}
                                    </div>
                                    <div className="single-beneficiary-right">
                                      <div className="single-beneficiary-header">
                                        <h1 className='beneficiary-name'>{row.beneficiary_name}</h1>
                                        <h1 className="relationship-type">{row.relationship_xx}</h1>
                                      </div>
                                      <div className="beneficiary-phone-row">
                                        <>
                                          <span className="beneficiary-phone-details">
                                            <MdAlternateEmail className="icon" /> <h1 className="sub-title">{row?.beneficiary_email}</h1>
                                          </span>
                                          <span className="beneficiary-phone-details">
                                            <MdPhone className="icon" /> <h1 className="sub-title">{row?.beneficiary_phone_no}</h1>
                                          </span>
                                          <>
                                            {!["Male", "Female"].includes(row?.beneficiary_gender) && <span className="beneficiary-phone-details"><TbGenderEpicene className="icon" /> {row?.beneficiary_gender}</span>}
                                            {["Male"].includes(row?.beneficiary_gender) && <span className="beneficiary-phone-details"><PiGenderMaleBold className="icon" /> {row?.beneficiary_gender}</span>}
                                            {["Female"].includes(row?.beneficiary_gender) && <span className="beneficiary-phone-details"><PiGenderFemaleBold className="icon" /> {row?.beneficiary_gender}</span>}
                                          </>
                                          <span className="beneficiary-phone-details"
                                            style={{ cursor: "pointer" }}
                                            onClick={() => navigate(`/entity/${row?.beneficiary_ent_docid}`)}>
                                            <TagIcon className="icon" /> <span>{row?.ben_ent_code}</span>
                                          </span>
                                        </>
                                        <span className="percentage">{`${row?.ben_percentage}%`}</span>
                                      </div>
                                    </div>
                                  </div>
                                ))}
                              </div>
                            </div>
                          </div>
                        </motion.div>}
                      {/* reserve movement */}

                      {reserveView === "reserve-details" &&
                        <motion.div
                          className="reserve-details"
                          initial={{ opacity: 0 }}
                          animate={{ opacity: 1, transition: { duration: 1 } }}
                          exit={{ opacity: 0, transition: { duration: 1 } }}>

                          <div className="reserve-card current" >
                            <div className="reserve-card-top">
                              <div className="reserve-card-badges">
                                <span className="reserve-pill priority--critical">{selectedIndex}</span>
                                {selectedReserve?.cr_type === "Own Damage" && <span className="reserve-pill priority--od">{selectedReserve?.cr_type}</span>}
                                {selectedReserve?.cr_type === "Service Provider" && <span className="reserve-pill priority--sp">{selectedReserve?.cr_type}</span>}
                                {selectedReserve?.cr_type === "Third Party" && <span className="reserve-pill priority--tp">{selectedReserve?.cr_type}</span>}
                              </div>

                              <div className={`reserve-status ${selectedReserve?.cr_status}`}>
                                <span className={`reserve-status-dot dot--green`} />
                                <span className="reserve-status-text">{selectedReserve?.cr_status}</span>
                              </div>
                            </div>

                            <div className="reserve-card-body">
                              <div className="reserve-main">

                                {selectedReserve?.cr_type === "Own Damage" && <>
                                  <div className="reserve-title">{claimData?.policy_xx?.insured_details_xx?.ent_name || ""}</div>
                                  <div className="reserve-desc">{selectedReserve?.cr_description || "-"}</div>
                                </>}

                                {selectedReserve?.cr_type === "Service Provider" && <>
                                  <div className="reserve-title">{selectedReserve?.entity_xx?.ent_name || ""}</div>
                                  <div className="reserve-desc">{selectedReserve?.cr_description || "-"}</div>
                                </>}

                                {selectedReserve?.cr_type === "Third Party" && <>
                                  <div className="reserve-desc">{selectedReserve?.cr_description || "-"}</div>
                                </>}

                                <div className="reserve-meta">
                                  <div className="reserve-meta-item">
                                    <Avatar name={selectedReserve?.updated_by_name_xx} photo={selectedReserve?.updated_by_photo_url_xx} size={28} />
                                    <span className="reserve-meta-label">
                                      {t('lastUpdatedBy')}:{" "}
                                      <span className="reserve-meta-strong">
                                        {selectedReserve?.updated_by_name_xx ? selectedReserve.updated_by_name_xx : "Unassigned"}
                                      </span>
                                    </span>
                                  </div>

                                  <div className="reserve-meta-item reserve-meta-item--time">
                                    <span className="reserve-clock" />
                                    <span className="reserve-meta-label"> {selectedReserve?.updated_ago_xx}</span>
                                  </div>
                                </div>
                              </div>
                              <div className="reserve-side">
                                <div className="reserve-sla">
                                  <div className="reserve-sla-top">
                                    <div className="reserve-desc">{t('currentReserve')?.toUpperCase()}</div>
                                    <div className="reserve-title">{numeral(selectedReserve?.cr_amount_fc).format("0,0.00")}</div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>

                          <div className="reserve-actions">
                            <h1 className="normal-title">{t('actions').toUpperCase()}</h1>
                            {selectedReserve?.reserve_actions_xx?.length > 0 ?
                              <div className="reserve-actions-wrapper">
                                {selectedReserve?.reserve_actions_xx?.map((action, index) => {
                                  const IconComponent = qilloIconMap[action?.icon] || GoHomeFill;
                                  return (
                                    <div key={action?._id}
                                      className={`${selectedReserveAction?._id === action?._id ? "reserve-action-item current" : "reserve-action-item"}`}
                                      onClick={async () => {
                                        try {
                                          console.log(`...action .. ${action}`);
                                          setSelectedReserveAction(action);
                                          // const path = `/${menu?.menu_function?.replace(/^\/+/, "")}`;
                                          // navigate(path, {
                                          //   replace: true,
                                          //   state: {
                                          //     showBack: "Y",
                                          //     menuDocid: menu?._id,
                                          //     favMenu: "Y"
                                          //   },
                                          // });
                                        } catch (error) {
                                          console.log(error);
                                        }
                                      }}>
                                      <IconComponent className="reserve-action-icon" />
                                      <div className="reserve-action-content">
                                        <div className="reserve-action-name">{action?.label}</div>
                                        <div className="reserve-action-description">{action?.value}</div>
                                      </div>
                                      <div style={{ display: "flex", flexDirection: "row", gap: "5px" }}>
                                        <span className="sub-title">{index + 1}</span>
                                      </div>
                                    </div>
                                  )
                                })}
                              </div>
                              :
                              <div className="no-action-wrapper">
                                <span className="main-title">{t('noActions')}</span>
                              </div>}
                          </div>
                          <div className="reserve-actions">
                            <h1 className="normal-title">{t('attachments').toUpperCase()}</h1>
                            <div className="attachment">
                              <FileUploadComponent
                                documentNo={cmClaimNo}
                                documentId={selectedReserve?._id}
                                documentType="claim-reserve"
                                fetchDocumentAttachments={fetchReserveAttachments}
                                uploadFolder={`cm-claim/${claimDocId}/claim-reserve/${selectedReserve?._id}`} />
                              <div className="attachment-files">
                                <AllFiles filesList={reserveAttachments} />
                              </div>
                            </div>
                          </div>
                          <div className="reserve-actions">
                            <h1 className="normal-title">{t('movement').toUpperCase()}</h1>
                            <div className="table-content" >
                              <TableContainer component={Paper} sx={{ border: 'none', boxShadow: 'none' }} className="table-container">
                                <Table sx={{ width: "max-content", border: 'none' }}>
                                  <TableHead className="tablehead">
                                    <TableRow className="tablerow">
                                      <TableCell className="table-cell center" style={{ display: "flex", maxWidth: "50px", fontWeight: "bold" }}>
                                        <span>#</span>
                                      </TableCell>
                                      <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                        <span>{t('date').toUpperCase()}</span>
                                      </TableCell>
                                      <TableCell className="table-cell right" style={{ maxWidth: "200px" }}>
                                        <span>{t('previousAmount').toUpperCase()}</span>
                                      </TableCell>
                                      <TableCell className="table-cell right" style={{ maxWidth: "200px" }}>
                                        <span>{t('currentAmount').toUpperCase()}</span>
                                      </TableCell>
                                      <TableCell className="table-cell left" style={{ width: "auto", paddingLeft: "10px" }}>
                                        <span>{t('doneBy').toUpperCase()}</span>
                                      </TableCell>
                                      <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                        <span>{t('when').toUpperCase()}</span>
                                      </TableCell>
                                      <TableCell className="table-cell center" style={{ maxWidth: "80px", }}>
                                        <span>{t('direction').toUpperCase()}</span>
                                      </TableCell>
                                    </TableRow>
                                  </TableHead>
                                  <TableBody className="tablebody">
                                    {selectedReserveMovement?.map((row, index) => (
                                      <TableRow
                                        key={row._id}
                                        className={`${currentReserveMovement?._id === row._id ? "tablerow current" : "tablerow"}`}
                                        onClick={() => setCurrentReserveMovement(row)}
                                      >
                                        <TableCell className="table-cell center" style={{ display: "flex", maxWidth: "50px", fontWeight: "bold" }}>
                                          <span>{currentPage * rowsPerPage + index + 1}</span>
                                        </TableCell>
                                        <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                          <span>{moment(row.createdAt).format("DD-MMM-YYYY")}</span>
                                        </TableCell>
                                        <TableCell className="table-cell right" style={{ maxWidth: "200px" }}>
                                          <span className='claim-details-field small'>{numeral(row.mvt_previous_amount_fc).format("0,0.00")}</span>
                                        </TableCell>
                                        <TableCell className="table-cell right" style={{ maxWidth: "200px" }}>
                                          <span className='claim-details-field small'>{numeral(row.mvt_current_amount_fc).format("0,0.00")}</span>
                                        </TableCell>
                                        <TableCell className="table-cell left" style={{ width: "auto", paddingLeft: "10px" }}>
                                          <div className="user">
                                            {row?.updated_by_photo_url_xx ?
                                              <img src={row?.updated_by_photo_url_xx} alt="" />
                                              : <InitialsAvatar
                                                name={row?.updated_by_name_xx}
                                                size={30}
                                                currentTheme={currentTheme}
                                              />}
                                            <span className='claim-details-field small'>{row?.updated_by_name_xx}</span>
                                          </div>
                                        </TableCell>
                                        <TableCell className="table-cell center" style={{ maxWidth: "100px" }}>
                                          <span className='claim-details-field small'>{row?.time_ago_xx}</span>
                                        </TableCell>
                                        <TableCell className="table-cell center" style={{ maxWidth: "80px", }}>
                                          {row?.direction_xx === "up" ? <IoMdArrowRoundUp className="direction-icon up" /> : <IoMdArrowRoundDown className="direction-icon down" />}
                                        </TableCell>
                                      </TableRow>
                                    ))}
                                  </TableBody>
                                </Table>
                              </TableContainer>
                            </div>
                          </div>
                        </motion.div>}
                    </ExpandableComponent>

                    <ExpandableComponent
                      title={
                        <div style={{ display: "flex", flexDirection: "row", gap: "10px", alignItems: "center" }}>
                          <span className="sub-title"> {t('injuries').toUpperCase()} </span>
                          <CircularButton
                            onClick={(e) => {
                              try {
                                e.stopPropagation();
                                setInjuredAction("add");
                                setInjuredDialogOpen(!injuredDialogOpen);
                              } catch (error) {
                                console.log(error);
                              }
                            }} icon={<MdAdd />} width={"30px"} height={"30px"} />
                        </div>
                      }
                      subtitle={""}
                      defaultExpanded={cmInjuredList?.length > 0}
                    >
                      <div className="injured-wrapper">
                        {cmInjuredList?.map((person) => (
                          <div key={person._id}>
                            <div
                              className="single-person"
                              onClick={() => {
                                try {
                                  setObjectToAction({
                                    object_id: person._id,
                                    action_text: "",
                                    new_doc_status: "amendInjured",
                                    param1: person?.full_name,
                                  });
                                  amendInjuredPerson(person);
                                } catch (error) {
                                  console.log(error);
                                }
                              }}
                            >
                              <div
                                style={{
                                  display: "flex",
                                  alignItems: "center",
                                  flexDirection: "row",
                                  justifyContent: "space-between",
                                  width: "100%",
                                  marginBottom: "10px",
                                }}
                              >
                                <span className="single-person-name">{person?.full_name}</span>
                                {documentEnabled === "Y" && (
                                  <Tooltip
                                    title={`Delete ${person?.full_name}`}
                                    placement="right"
                                    style={{
                                      backgroundColor: "blue",
                                      color: "white",
                                    }}
                                  >
                                    <MdDelete
                                      size={50}
                                      style={{
                                        borderRadius: "5px",
                                        padding: "3px",
                                        alignSelf: "center",
                                        cursor: "pointer",
                                        color: "rgba(244, 67, 54)",
                                        backgroundColor: "rgba(244, 67, 54, 0.5)",
                                      }}
                                      onClick={(e) => {
                                        try {
                                          e.stopPropagation();
                                          let action_text = `Delete ${person?.full_name}?`;
                                          setObjectToAction({
                                            object_id: person._id,
                                            action_text: action_text,
                                            new_doc_status: "deleteInjured",
                                            param1: person?.full_name,
                                            param2: "",
                                          });

                                          setConfirmDialogAction("deleteInjured");
                                          setIsConfirmDialogOpen(true);
                                        } catch (error) {
                                          console.log(error);
                                        }
                                      }}
                                    />
                                  </Tooltip>
                                )}
                              </div>
                              <span className="single-person-desc">{person?.injured_desc_xx}</span>
                            </div>
                          </div>
                        ))}
                      </div>
                    </ExpandableComponent>
                  </motion.div>
                }
                {/* Attachments */}
                {activeTab === 1 &&
                  <div className="attachment">
                    <FileUploadComponent
                      documentNo={cmClaimNo}
                      documentId={claimDocId}
                      documentType="CM Claim"
                      fetchDocumentAttachments={fetchDocumentAttachments}
                      uploadFolder={`cm-claim/${claimDocId}`} />
                    <div className="attachment-files">
                      <AllFiles filesList={attachmentsData} whatsappAllowed={"Y"}
                        phoneNo={claimData?.policy_xx?.insured_details_xx?.ent_whatsapp_no} />
                    </div>
                  </div>}
                {/* correspondence */}
                {activeTab === 2 &&
                  <motion.div
                    className="tabs-view-wrapper"
                    initial={{ opacity: 0 }}
                    animate={{ opacity: 1, transition: { duration: 1 } }}
                    exit={{ opacity: 0, transition: { duration: 1 } }}
                  >
                    <div className="correspondence">
                      <Correspondence
                        correspondenceParams={{ fetch_type: "document", doc_id: claimData._id, doc_no: claimData?.cm_our_ref, doc_type: "Claim", entity_codes: [claimData?.insured_code_xx, claimData?.carrier_code_xx] }}
                        passedEmailData={{
                          to: claimData?.policy_xx?.insured_details_xx?.ent_email,
                          cc: '',
                          bcc: '',
                          subject: '',
                          show_attach: "Y",
                          attached_urls: [],
                          binary_docs: [],
                          doc_no: claimData?.cm_our_ref,
                          doc_type: "Claim",
                          doc_id: claimDocId,
                          entity_codes: [claimData?.policy_xx?.insured_details_xx?.ent_code, claimData?.policy_xx?.carrier_details_xx?.ent_code],
                          search_string: claimData?.policy_xx?.insured_details_xx?.ent_code + "," + claimData?.policy_xx?.carrier_details_xx?.ent_name + "," + claimData?.cm_our_ref + "," + cmClaimNo,
                          carrierName: claimData?.policy_xx?.carrier_details_xx?.ent_name,
                          productName: claimData?.policy_xx?.product_name_xx,
                          clientName: claimData?.policy_xx?.insured_details_xx?.ent_code,
                          riskNoteNo: cmRiskNoteNo,
                          daysToRenewal: claimData?.expiring_in_days,
                          expiryDate: claimData?.fmt_to_date,
                          insuredName: claimData?.policy_xx?.insured_details_xx?.ent_name,
                          outstandingPremium: claimData?.total_os_fc_amount,
                          policyCurrency: claimData?.policy_xx?.currency_xx,
                          policyNumber: cmPolicyNo,
                          policyPremium: claimData?.fmt_policy_fc_prem,
                          policyPremiumTotal: claimData?.fmt_total_fc_prem,
                          policySumInsured: claimData?.fmt_total_fc_si,
                          policyFromDate: claimData?.fmt_fm_date,
                          policyToDate: claimData?.fmt_to_date,
                          claimCurrentStage: cmStage?.label,
                          claimDesc: cmDescription,
                          claimIntimationDate: claimData?.fmt_intimation_date,
                          claimLossDate: claimData?.fmt_loss_date,
                          claimNo: claimData?.cm_claim_no,
                          claimOurRef: claimData?.cm_our_ref,
                          tpt_category: ["claimDocuments", "claimAcknowledgment"]
                        }} />
                    </div>
                  </motion.div>
                }
                {/* Notes */}
                {activeTab === 3 &&
                  <AllDocsNote
                    docId={claimData._id}
                    docType="Claim"
                    noteType={"Normal"}
                  />
                }
              </div>
            </div>
            <div className="document-summary-wrapper">
              <div className="worked-on-by-container">
                <div className="panel-card" style={{ padding: "10px" }}>
                  <WorkedOnBy
                    name={claimData?.updated_by_name_xx}
                    photoUrl={claimData?.updated_by_photo_url_xx}
                    time_ago_xx={claimData?.time_ago_xx}
                  />
                </div>
              </div>

              <div className="document-summary-content">
                <div className="summary-view" >
                  {/* ===================== SUMMARY CARD ===================== */}
                  <div className="panel-card">
                    <div className="panel-card__header">
                      <div className="panel-card__titleRow">
                        <h1 className="panel-card__title">{t("summary").toUpperCase()}</h1>
                        <span className="panel-card__currency">
                          {claimData?.policy_xx?.pl_cur_code}
                        </span>
                      </div>
                      <div className="panel-card__divider" />
                    </div>

                    <div className="panel-card__body">
                      <div className="kv-row">
                        <span className="kv-key">{t("sumInsured").toUpperCase()}</span>
                        <span className="kv-val">  {numeral(claimData?.policy_xx?.total_fc_si).format("0,0.00")}   </span>
                      </div>

                      <div className="kv-row">
                        <span className="kv-key">{t("premium").toUpperCase()}</span>
                        <span className="kv-val">
                          {numeral(claimData?.policy_xx?.total_fc_premium).format("0,0.00")}
                        </span>
                      </div>

                      <div className="kv-row">
                        <span className="kv-key">{t("paidPremium").toUpperCase()}</span>
                        <span className="kv-val">
                          {numeral(claimData?.policy_xx?.total_paid_fc_amount).format("0,0.00")}
                        </span>
                      </div>



                      {/* O/S PREMIUM pill (moved from inline styles to SCSS) */}
                      <div
                        className={`pill-row ${claimData?.policy_xx?.total_os_fc_amount > 0
                          ? "pill-row--danger"
                          : "pill-row--success"
                          }`}
                      >
                        <span className="pill-label">{t("osPremium").toUpperCase()}</span>
                        <span className="pill-value">
                          {numeral(claimData?.policy_xx?.total_os_fc_amount).format("0,0.00")}
                        </span>
                      </div>
                      <div
                        className={`pill-row ${claimData?.claim_reserve_amount_fc > 0
                          ? "pill-row--reserve"
                          : "pill-row--success"
                          }`}
                      >
                        <span className="pill-label">{t("claimAmount").toUpperCase()}</span>
                        <span className="pill-value">
                          {numeral(claimData?.claim_reserve_amount_fc).format("0,0.00")}
                        </span>
                      </div>

                    </div>
                  </div>

                  <div className="panel-card">
                    <div className="panel-card__header">
                      <div className="panel-card__titleRow">
                        <h1 className="panel-card__title">{t("summary").toUpperCase()}</h1>
                        <span className="panel-card__currency">
                          {claimData?.policy_xx?.pl_cur_code}
                        </span>
                      </div>
                      <div className="panel-card__divider" />
                    </div>
                    <GaugePointer value={claimData?.cm_awareness_score || 0} currentTheme={currentTheme} />
                  </div>
                  {claimData?.cm_related_claims?.length > 0 &&
                    <div className="panel-card">
                      <div className="panel-card__header">
                        <div className="panel-card__titleRow">
                          <span className="panel-card__title">{t('relatedClaims').toUpperCase()}</span>
                        </div>
                        <div className="panel-card__divider" />
                      </div>
                      <div className="panel-card__body">
                        {claimData?.cm_related_claims?.map((rela, index) => (
                          <div key={rela.claim_docid}>
                            <div className="kv-row">
                              <h1
                                className="kv-key"
                              >
                                {index + 1}.
                              </h1>
                              <h1 className="kv-key"
                                onClick={() => {
                                  try {
                                    // Ensure rela.claim_docid exists
                                    if (rela && rela.claim_docid) {
                                      setClaimDocId(rela.claim_docid);
                                      navigate(`/cm/${rela.claim_docid}`, { replace: true });
                                    } else {
                                      console.log("Invalid claim ID");
                                    }
                                  } catch (error) {
                                    console.error("Navigation error:", error);
                                  }
                                }}
                              >
                                <span
                                  dangerouslySetInnerHTML={{
                                    __html: rela.claim_no || "No claim number",
                                  }}
                                />
                              </h1>
                            </div>
                          </div>
                        ))}
                      </div>
                    </div>}
                  {summaryNotesXx?.length > 0 &&
                    <div className="panel-card">
                      <div className="panel-card__header">
                        <div className="panel-card__titleRow">
                          <span className="panel-card__title">{t('pleaseNote').toUpperCase()}</span>
                        </div>
                        <div className="panel-card__divider" />
                      </div>
                      <div className="please-note-list">
                        {summaryNotesXx?.map((claim, index) => (
                          <div key={claim._id} className="please-note-item">
                            <h1 className="please-note-text">{index + 1}. </h1>
                            <h1 className="please-note-text">{claim.summary_text}</h1>
                          </div>
                        ))}
                      </div>
                    </div>}
                </div>

                <div className="dra">
                  <Drawer
                    anchor="right"
                    sx={{
                      '& .MuiDrawer-paper': {
                        borderTopLeftRadius: "5px",
                        borderBottomLeftRadius: "5px",
                        height: '75%',
                        top: '100px',
                      },
                    }}
                    open={openDrawer}
                    onClose={toggleDrawer(false)}>
                    {DrawerList}
                  </Drawer>
                </div>
              </div>
            </div>
          </div>
          <Collaborator
            open={isCollabOpen}
            docType={"Claim"}
            docNo={claimData?.cm_our_ref}
            docId={claimData?._id}
            currentTheme={currentTheme}
            onClose={closeCollab}
            rightOffset={collabRightOffset}
            currentUser={currentUser}
          />
        </div>
      )}

      {/* Dialog to notify user about changes being saved */}
      <Dialog open={isNotifyDialogOpen}
        onClose={() => setIsNotifyDialogOpen(false)}
       PaperProps={{
          sx: {
            borderRadius: "16px",
            backgroundColor: currentTheme === "dark" ? "#181A20" : "#fff",
            color: currentTheme === "dark" ? "#fff" : "#000",
          },
        }}
        slotProps={{
          backdrop: {
            sx: {
              backgroundColor: "rgba(0, 0, 0, 0.7)",
            },
          },
        }}>
        <DialogTitle>{notifyDialogTitle}</DialogTitle>
        <DialogContent>
          <div dangerouslySetInnerHTML={{ __html: notifyDialogText }} />
        </DialogContent>
        <DialogActions>
          <CustomLoadingButton currentTheme={currentTheme} variant="tint" color="#E040FB" onClick={() => setIsNotifyDialogOpen(false)}>{t('close')}</CustomLoadingButton>
        </DialogActions>
      </Dialog>
      {/* Confirm Dialog */}
      <ConfirmDialog
        isOpen={isConfirmDialogOpen}
        onClose={() => setIsConfirmDialogOpen(false)}
        onConfirm={handleConfirm}
        dialogTitle={t('confirmation')}
        dialogContent={<p dangerouslySetInnerHTML={{ __html: objectToAction?.action_text }} />}
      />
      {isProcessing && (
        <motion.div
          className="processing-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="processing-wrapper">
            <GridLoader color="#bd97fc"
              style={{
                height: "50px",
                width: "50px",
              }}
            />
          </div>
        </motion.div>
      )}
      {isConfettiActive && <Confetti />}
      {/* add injured person */}
      {injuredDialogOpen && (
        <motion.div
          className="injured-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="injured-wrapper">
            <div className="injured-navbar">
              <h1 className="main-title">{t('injuredPerson').toUpperCase()}</h1>
              <CircularButton
                currentTheme={currentTheme}
                onClick={() => {
                  try {
                    resetInjuredData();
                    setInjuredDialogOpen(false);
                  } catch (error) {
                    console.log(error);
                  }
                }} icon={<IoClose />}
                width={"35px"}
                height={"35px"} />
            </div>
            <div className="injured-content">
              <div className="input-item-with-label">
                <label
                  htmlFor="injuredFullName"
                  className="form-dropdown-label"
                  style={{ width: "100px" }}
                >
                  {t('fullName').toUpperCase()}
                </label>
                <input
                  id="injuredFullName"
                  name="injuredFullName"
                  type="text"
                  value={injuredFullName}
                  className="form-input-item"
                  style={{ width: "275px" }}
                  disabled={documentEnabled === "N"}
                  onChange={(e) => setInjuredFullName(e.target.value)}
                />
              </div>
              <div className="input-item-with-label">
                <label
                  htmlFor="injuredIdNumber"
                  className="form-dropdown-label"
                  style={{ width: "100px" }}
                >
                  {t('idNumber').toUpperCase()}
                </label>
                <input
                  id="injuredIdNumber"
                  name="injuredIdNumber"
                  type="text"
                  value={injuredIdNumber}
                  className="form-input-item"
                  style={{ width: "275px" }}
                  disabled={documentEnabled === "N"}
                  onChange={(e) => setInjuredIdNumber(e.target.value)}
                />
              </div>
              <div
                style={{
                  display: "flex",
                  flexDirection: "row",
                  width: "100%",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <div className="input-item-with-label">
                  <label htmlFor="injuredAge"
                    className="form-dropdown-label"
                    style={{ width: "100px" }}>
                    {t('age')}
                  </label>
                  <input
                    id="injuredAge"
                    name="injuredAge"
                    type="number"
                    value={injuredAge}
                    className="form-input-item"
                    style={{ width: "70px" }}
                    disabled={documentEnabled === "N"}
                    onChange={(e) => setInjuredAge(e.target.value)}
                  />
                </div>
                <div className="input-item-with-label">
                  <label
                    htmlFor="injuredGender"
                    className="form-dropdown-label"
                    style={{ width: "max-content" }}
                  >
                    {t('gender').toUpperCase()}
                  </label>
                  <Select
                    id="injuredGender"
                    name="injuredGender"
                    menuPortalTarget={document.body}
                    styles={{
                      ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                      menuPortal: base => ({
                        ...base,
                        zIndex: 9999,
                      })
                    }}
                    width="120px"
                    value={injuredGender}
                    onChange={(selectedOption) => {
                      try {
                        setInjuredGender(selectedOption);
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                    options={genders}
                    isSearchable={true}
                    placeholder="Select"
                    isDisabled={documentEnabled === "N"}
                  />
                </div>
              </div>
              <div className="input-item-with-label">
                <label
                  htmlFor="injuredInjuryDesc"
                  className="form-dropdown-label"
                  style={{ width: "100px", alignSelf: "flex-start" }}
                >
                  {t('description').toUpperCase()}
                </label>
                <textarea
                  id="injuredInjuryDesc"
                  name="injuredInjuryDesc"
                  type="text"
                  rows={5}
                  value={injuredInjuryDesc}
                  className="form-input-item"
                  style={{ width: "275px" }}
                  disabled={documentEnabled === "N"}
                  onChange={(e) => setInjuredInjuryDesc(e.target.value)}
                />
              </div>
              <div
                style={{
                  width: "100px",
                  alignItems: "center",
                  justifyContent: "flex-end",
                }}
              >
                <ToggleSwitch
                  id="injuredFatal"
                  value={injuredFatal}
                  onChange={setInjuredFatal}
                  label={t('fatal').toUpperCase()}
                  labelPosition={"start"}
                  labelWidth={"max-content"}
                  style={{
                    width: "100px",
                    alignSelf: "flex-end !important",
                  }}
                  disabled={documentEnabled === "N"}
                />
              </div>
            </div>
            <div className="injured-action">
              {documentEnabled === "Y" && (
                <CustomLoadingButton onClick={handleInsuredPerson}>{`${injuredAction === "amend" ? "Update" : "Add"
                  }`}</CustomLoadingButton>
              )}
            </div>
          </div>
        </motion.div>
      )}
      {/* claim close reasons */}
      {isCloseDialogOpened && (
        <motion.div
          className="injured-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="injured-wrapper">
            <div className="injured-navbar">
              <span>{t('closeClaim').toUpperCase()}</span>
              <CircularButton
                currentTheme={currentTheme}
                onClick={() => {
                  try {
                    setIsCloseDialogOpened(false);
                  } catch (error) {
                    console.log(error);
                  }
                }} icon={<IoClose />} width={"35px"} height={"35px"} />

            </div>
            <div className="injured-content">
              <div className="input-item-with-label">
                <label
                  htmlFor="close_reason"
                  className="form-dropdown-label"
                  style={{ width: "130px" }}
                >
                  {t('reason').toUpperCase()}
                </label>
                <CreatableSelect
                  id="close_reason"
                  name="close_reason"
                  menuPortalTarget={document.body}
                  styles={{
                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                    menuPortal: base => ({
                      ...base,
                      zIndex: 9999,
                    })
                  }}
                  width="350px"
                  value={selectedCloseReason}
                  onChange={handleSelectedCloseReason}
                  options={closeReasons}
                  isSearchable={true}
                  placeholder="Select Reason"
                />
              </div>
              <div className="input-item-with-label">
                <label
                  htmlFor="closeRemarks"
                  className="form-dropdown-label"
                  style={{ width: "130px", alignSelf: "flex-start" }}
                >
                  {t('remarks').toUpperCase()}
                </label>
                <textarea
                  id="closeRemarks"
                  name="closeRemarks"
                  type="text"
                  rows={5}
                  value={closeRemarks}
                  className="form-input-item"
                  style={{ width: "350px" }}
                  disabled={documentEnabled === "N"}
                  onChange={(e) => setCloseRemarks(e.target.value)}
                />
              </div>
            </div>
            <div className="injured-action">
              <CustomLoadingButton onClick={handleCloseClaim}>{t('close')}</CustomLoadingButton>
            </div>
          </div>
        </motion.div>
      )}
      {/* claim reopen reasons */}
      {isReopenDialogOpened && (
        <motion.div
          className="injured-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="injured-wrapper">
            <div className="injured-navbar">
              <span>{t('reopenClaim').toUpperCase()}</span>
              <CircularButton
                currentTheme={currentTheme}
                onClick={() => {
                  try {
                    setIsReopenDialogOpened(false);
                  } catch (error) {
                    console.log(error);
                  }
                }} icon={<IoClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="injured-content">
              <div className="input-item-with-label">
                <label
                  htmlFor="reopen_reason"
                  className="form-dropdown-label"
                  style={{ width: "130px" }}
                >
                  {t('reason').toUpperCase()}
                </label>
                <CreatableSelect
                  id="reopen_reason"
                  name="reopen_reason"
                  menuPortalTarget={document.body}
                  styles={{
                    ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                    menuPortal: base => ({
                      ...base,
                      zIndex: 9999,
                    })
                  }}
                  width="350px"
                  value={selectedReopenReason}
                  onChange={handleSelectedReopenReason}
                  options={reopenReasons}
                  isSearchable={true}
                  placeholder="Select Reason"
                />
              </div>

              <div className="input-item-with-label">
                <label
                  htmlFor="reopenRemarks"
                  className="form-dropdown-label"
                  style={{ width: "130px", alignSelf: "flex-start" }}
                >
                  {t('remarks').toUpperCase()}
                </label>
                <textarea
                  id="reopenRemarks"
                  name="reopenRemarks"
                  type="text"
                  rows={5}
                  value={reopenRemarks}
                  className="form-input-item"
                  style={{ width: "350px" }}
                  onChange={(e) => setReopenRemarks(e.target.value)}
                />
              </div>
            </div>
            <div className="injured-action">
              <CustomLoadingButton onClick={handleReopenClaim}>Reopen</CustomLoadingButton>
            </div>
          </div>
        </motion.div>
      )}
      {/* email component */}
      {emailDialogOpen && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">EMAIL</h1>
              <CircularButton
                currentTheme={currentTheme}
                onClick={() => setEmailDialogOpen(false)} icon={<IoClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <EmailComponent setEmailDialogOpen={setEmailDialogOpen} emailData={emailData} />
            </div>
          </div>
        </motion.div>
      )}
      {isReserveOpened && (
        <motion.div
          className="injured-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="injured-wrapper">
            <div className="injured-navbar">
              <h1 className="main-title">{t('reserve').toUpperCase()}</h1>
              <CircularButton currentTheme={currentTheme} onClick={() => setIsReserveOpened(false)} icon={<IoClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="injured-content">
              {reserveAction === "add" &&
                <div className="input-item-with-label">
                  <label
                    htmlFor="reserve_type"
                    className="form-dropdown-label"
                    style={{ width: "130px" }}
                  >
                    {t('type').toUpperCase()}
                  </label>
                  <Select
                    id="reserve_type"
                    name="reserve_type"
                    menuPortalTarget={document.body}
                    styles={{
                      ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                      menuPortal: base => ({
                        ...base,
                        zIndex: 9999,
                      })
                    }}
                    width="200px"
                    value={reserveType}
                    onChange={(selectedOption) => {
                      try {
                        setReserveType(selectedOption);
                      } catch (error) {
                        console.log(error);
                      }
                    }}
                    options={reserveTypes}
                    isSearchable={true}
                    placeholder="Select"
                  />
                </div>}
              {reserveType?.value === "Service Provider" &&
                <div className="input-item-with-label">
                  <label
                    htmlFor="reserve_entity"
                    className="form-dropdown-label"
                    style={{ width: "130px" }}
                  >
                    {t('entity').toUpperCase()}
                  </label>
                  <AsyncSelect
                    id="reserve_entity"
                    name="reserve_entity"
                    menuPortalTarget={document.body}
                    styles={{
                      ...(currentTheme === "dark" ? customSelectStyles_dark : customSelectStyles_light),
                      menuPortal: base => ({
                        ...base,
                        zIndex: 9999,
                      })
                    }}
                    width="350px"
                    value={reserveEntity}
                    onChange={(selectedOption) => setReserveEntity(selectedOption)}
                    loadOptions={fetchClientsBySearch}
                    isSearchable={true}
                    isDisabled={documentEnabled === "N"}
                    placeholder={`${reserveType?.label || "ENTITY"}`}
                    noOptionsMessage={() => "Search Clients"}
                  />
                </div>}
              <div className="input-item-with-label">
                <label
                  htmlFor="reserve_amount"
                  className="form-dropdown-label"
                  style={{ width: "130px" }}
                >
                  {t('amount').toUpperCase()}
                </label>
                <input
                  id="reserve_amount"
                  name="reserve_amount"
                  type="text"
                  placeholder="0.00"
                  value={reserveAmountFc}
                  className="form-input-item"
                  style={{ width: "350px", textAlign: "right" }}
                  onChange={(e) => setReserveAmountFc(e.target.value)}
                  onBlur={handleReserveFcAmountBlur}
                />
              </div>
              <div className="input-item-with-label">
                <label
                  htmlFor="reserveDesc"
                  className="form-dropdown-label"
                  style={{ width: "130px", alignSelf: "flex-start" }}
                >
                  {t('narration').toUpperCase()}
                </label>
                <textarea
                  id="reserveDesc"
                  name="reserveDesc"
                  type="text"
                  rows={4}
                  value={reserveDesc}
                  className="form-input-item"
                  style={{ width: "350px" }}
                  disabled={documentEnabled === "N"}
                  onChange={(e) => setReserveDesc(e.target.value)}
                  onKeyDown={handleKeyDown}
                />
              </div>
              {reserveAction === "edit" && <h1 className="sub-title">{`PLEASE NOTE: Setting the reserve amount to ZERO will close this reserve.`}</h1>}
            </div>
            <div className="injured-action">
              <CustomLoadingButton onClick={handleReserveAddUpdate}>{`${reserveAction === "add" ? "Add" : "Update"}`}</CustomLoadingButton>
            </div>
          </div>
        </motion.div>
      )}
      {reportsDialogOpen && (
        <motion.div
          className="overlay-dialog reports"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}
        >
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{t('reports')}</h1>
              <CircularButton currentTheme={currentTheme} onClick={() => setReportsDialogOpen(false)} icon={<MdClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <OnScreenReports
                reportGroup={claimData?.report_group}
                documentData={{
                  docNo: claimData?.cm_our_ref,
                  docType: "Claim",
                  docId: claimDocId,
                  claim_docid: claimDocId
                }} />
            </div>
          </div>
        </motion.div>
      )}
      {placesDialogOpen && (
        <motion.div
          className="overlay-dialog"
          initial={{ opacity: 0 }}
          animate={{ opacity: 1, transition: { duration: 1 } }}
          exit={{ opacity: 0, transition: { duration: 1 } }}>
          <div className="overlay-wrapper">
            <div className="overlay-navbar">
              <h1 className="main-title">{t('place')}</h1>
              <CircularButton currentTheme={currentTheme} onClick={() => setPlacesDialogOpen(false)} icon={<IoClose />} width={"35px"} height={"35px"} />
            </div>
            <div className="overlay-content">
              <GooglePlacesSelect onPlaceSelect={handlePlaceSelect} />
              {selectedPlace && (
                <div style={{ display: "flex", flexDirection: "column", gap: "5px", marginTop: "10px" }}>
                  {/* <hr className='separator-h' /> */}
                  <span className='sub-title'>{`${t('place')} : ${selectedPlace.label}`}</span>
                  <span className='sub-title'>{`${t('latitude')} : ${selectedPlace.coordinates.lat}`}</span>
                  <span className='sub-title'>{`${t('longitude')} : ${selectedPlace.coordinates.lng}`}</span>
                </div>
              )}
            </div>
            <div className="overlay-actions">
              <CustomLoadingButton
                currentTheme={currentTheme}
                onClick={() => {
                  try {
                    setCmLatitude(selectedPlace?.coordinates.lat);
                    setCmLongitude(selectedPlace?.coordinates.lng);
                    setCmPlaceName(selectedPlace?.label);
                    setPlacesDialogOpen(false);
                  } catch (error) {
                    console.log(error);
                  }
                }}
                disabled={!selectedPlace}
              >
                {t('select').toUpperCase()}
              </CustomLoadingButton>
            </div>
          </div>
        </motion.div>
      )}
    </motion.div>
  );
};

const getInitials = (name = "") => {
  const parts = String(name).trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "U";
  if (parts.length === 1) return parts[0].slice(0, 2).toUpperCase();
  return (parts[0][0] + parts[1][0]).toUpperCase();
};



const Avatar = ({ name, photo, size = 30 }) => {
  const initials = getInitials(name);
  return photo ? (
    <img
      src={photo}
      alt=""
      className="reserve-avatar-img"
      style={{ width: size, height: size }}
    />
  ) : (
    <div className="reserve-avatar-fallback" style={{ width: size, height: size }}>
      {initials}
    </div>
  );
};

export default CmClaim;
